import { _ as _extends } from '../../dist/extends-a2cb9f0c.esm.js';
import dayjs from 'dayjs';
import * as React from 'react';
import React__default, { useState, useEffect, useRef } from 'react';
import { View, StyleSheet } from 'react-native';
import { GiftedChat, InputToolbar, Composer, Bubble, Send } from 'react-native-gifted-chat';
import { A as AppAssets } from '../../dist/index-3256db5b.esm.js';
import { u as useTheme } from '../../dist/useTheme-90e8e2c2.esm.js';
import { A as AppActivityIndicator } from '../../dist/index-2b5eefb0.esm.js';
import { A as AppAvatar } from '../../dist/index-ec953df8.esm.js';
import { A as AppFadeView } from '../../dist/index-948166a0.esm.js';
import { A as AppText, a as AppIcon } from '../../dist/index-6b88191c.esm.js';
import { M as MessageFeedback } from '../../dist/MessageFeedback-fa51e3be.esm.js';
import '@fortawesome/pro-light-svg-icons/faAdjust';
import '@fortawesome/pro-light-svg-icons/faAlignCenter';
import '@fortawesome/pro-light-svg-icons/faAlignLeft';
import '@fortawesome/pro-light-svg-icons/faAlignRight';
import '@fortawesome/pro-light-svg-icons/faArrowCircleRight';
import '@fortawesome/pro-light-svg-icons/faArrowSquareLeft';
import '@fortawesome/pro-light-svg-icons/faArrowToRight';
import '@fortawesome/pro-light-svg-icons/faBan';
import '@fortawesome/pro-light-svg-icons/faBars';
import '@fortawesome/pro-light-svg-icons/faBell';
import '@fortawesome/pro-light-svg-icons/faBezierCurve';
import '@fortawesome/pro-light-svg-icons/faBold';
import '@fortawesome/pro-light-svg-icons/faBookOpen';
import '@fortawesome/pro-light-svg-icons/faBookReader';
import '@fortawesome/pro-light-svg-icons/faBookmark';
import '@fortawesome/pro-light-svg-icons/faBooks';
import '@fortawesome/pro-light-svg-icons/faBracketsCurly';
import '@fortawesome/pro-light-svg-icons/faBrain';
import '@fortawesome/pro-light-svg-icons/faHeadSideBrain';
import '@fortawesome/pro-light-svg-icons/faBrowser';
import '@fortawesome/pro-light-svg-icons/faCalendarDay';
import '@fortawesome/pro-light-svg-icons/faCalendarEdit';
import '@fortawesome/pro-light-svg-icons/faFileChartLine';
import '@fortawesome/pro-light-svg-icons/faChartColumn';
import '@fortawesome/pro-light-svg-icons/faChartNetwork';
import '@fortawesome/pro-light-svg-icons/faCheckCircle';
import '@fortawesome/pro-light-svg-icons/faChevronDoubleUp';
import '@fortawesome/pro-light-svg-icons/faChevronDown';
import '@fortawesome/pro-light-svg-icons/faChevronLeft';
import '@fortawesome/pro-light-svg-icons/faScannerTouchscreen';
import '@fortawesome/pro-light-svg-icons/faChevronRight';
import '@fortawesome/pro-light-svg-icons/faChevronUp';
import '@fortawesome/pro-light-svg-icons/faCircle';
import '@fortawesome/pro-light-svg-icons/faClipboard';
import '@fortawesome/pro-light-svg-icons/faClipboardListCheck';
import '@fortawesome/pro-light-svg-icons/faSparkles';
import '@fortawesome/pro-light-svg-icons/faClock';
import '@fortawesome/pro-light-svg-icons/faClone';
import '@fortawesome/pro-light-svg-icons/faCloudDownload';
import '@fortawesome/pro-light-svg-icons/faCloudUpload';
import '@fortawesome/pro-light-svg-icons/faCode';
import '@fortawesome/pro-light-svg-icons/faCodeMerge';
import '@fortawesome/pro-light-svg-icons/faCog';
import '@fortawesome/pro-light-svg-icons/faCommentAltLines';
import '@fortawesome/pro-light-svg-icons/faCommentLines';
import '@fortawesome/pro-light-svg-icons/faCommentsAlt';
import '@fortawesome/pro-light-svg-icons/faCompressAlt';
import '@fortawesome/pro-light-svg-icons/faCopy';
import '@fortawesome/pro-light-svg-icons/faCreditCard';
import '@fortawesome/pro-light-svg-icons/faDatabase';
import '@fortawesome/pro-light-svg-icons/faDollarSign';
import '@fortawesome/pro-light-svg-icons/faEdit';
import '@fortawesome/pro-light-svg-icons/faEllipsisH';
import '@fortawesome/pro-light-svg-icons/faEllipsisV';
import '@fortawesome/pro-light-svg-icons/faEnvelopeOpenText';
import '@fortawesome/pro-light-svg-icons/faEraser';
import '@fortawesome/pro-light-svg-icons/faExchangeAlt';
import '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import '@fortawesome/pro-light-svg-icons/faExpandAlt';
import '@fortawesome/pro-light-svg-icons/faExpandWide';
import '@fortawesome/pro-light-svg-icons/faEye';
import '@fortawesome/pro-light-svg-icons/faEyeSlash';
import '@fortawesome/pro-light-svg-icons/faFile';
import '@fortawesome/pro-light-svg-icons/faFileAlt';
import '@fortawesome/pro-light-svg-icons/faFileCode';
import '@fortawesome/pro-light-svg-icons/faFileCsv';
import '@fortawesome/pro-light-svg-icons/faFileExcel';
import '@fortawesome/pro-light-svg-icons/faFileExport';
import '@fortawesome/pro-light-svg-icons/faFileImport';
import '@fortawesome/pro-light-svg-icons/faFileInvoiceDollar';
import '@fortawesome/pro-light-svg-icons/faFilePdf';
import '@fortawesome/pro-light-svg-icons/faFilePowerpoint';
import '@fortawesome/pro-light-svg-icons/faFileSignature';
import '@fortawesome/pro-light-svg-icons/faFileUpload';
import '@fortawesome/pro-light-svg-icons/faFileWord';
import '@fortawesome/pro-light-svg-icons/faFolder';
import '@fortawesome/pro-light-svg-icons/faFont';
import '@fortawesome/pro-light-svg-icons/faGameBoardAlt';
import '@fortawesome/pro-light-svg-icons/faGlobeEurope';
import '@fortawesome/pro-light-svg-icons/faGlobePointer';
import '@fortawesome/pro-light-svg-icons/faGripLinesVertical';
import '@fortawesome/pro-light-svg-icons/faGripVertical';
import '@fortawesome/pro-light-svg-icons/faH1';
import '@fortawesome/pro-light-svg-icons/faH2';
import '@fortawesome/pro-light-svg-icons/faHashtag';
import '@fortawesome/pro-light-svg-icons/faHighlighter';
import '@fortawesome/pro-light-svg-icons/faHistory';
import '@fortawesome/pro-light-svg-icons/faHomeAlt';
import '@fortawesome/pro-light-svg-icons/faImage';
import '@fortawesome/pro-light-svg-icons/faInbox';
import '@fortawesome/pro-light-svg-icons/faIndent';
import '@fortawesome/pro-light-svg-icons/faInfoCircle';
import '@fortawesome/pro-light-svg-icons/faItalic';
import '@fortawesome/pro-light-svg-icons/faKeyboard';
import '@fortawesome/pro-light-svg-icons/faLanguage';
import '@fortawesome/pro-light-svg-icons/faLaptopCode';
import '@fortawesome/pro-light-svg-icons/faLayerGroup';
import '@fortawesome/pro-light-svg-icons/faLightbulbExclamation';
import '@fortawesome/pro-light-svg-icons/faLink';
import '@fortawesome/pro-light-svg-icons/faListOl';
import '@fortawesome/pro-light-svg-icons/faListUl';
import '@fortawesome/pro-light-svg-icons/faLock';
import '@fortawesome/pro-light-svg-icons/faLockOpen';
import '@fortawesome/pro-light-svg-icons/faMeteor';
import '@fortawesome/pro-light-svg-icons/faMicrophone';
import '@fortawesome/pro-light-svg-icons/faMoneyCheckAlt';
import '@fortawesome/pro-light-svg-icons/faNetworkWired';
import '@fortawesome/pro-light-svg-icons/faPaintRoller';
import '@fortawesome/pro-light-svg-icons/faPaperPlaneTop';
import '@fortawesome/pro-light-svg-icons/faPen';
import '@fortawesome/pro-light-svg-icons/faPlanetRinged';
import '@fortawesome/pro-light-svg-icons/faPlus';
import '@fortawesome/pro-light-svg-icons/faPlusCircle';
import '@fortawesome/pro-light-svg-icons/faPowerOff';
import '@fortawesome/pro-light-svg-icons/faQuestion';
import '@fortawesome/pro-light-svg-icons/faQuestionCircle';
import '@fortawesome/pro-light-svg-icons/faQuoteLeft';
import '@fortawesome/pro-light-svg-icons/faRedo';
import '@fortawesome/pro-light-svg-icons/faReply';
import '@fortawesome/pro-light-svg-icons/faRocketLaunch';
import '@fortawesome/pro-light-svg-icons/faSatelliteDish';
import '@fortawesome/pro-light-svg-icons/faScrubber';
import '@fortawesome/pro-light-svg-icons/faSearch';
import '@fortawesome/pro-light-svg-icons/faSearchMinus';
import '@fortawesome/pro-light-svg-icons/faSearchPlus';
import '@fortawesome/pro-light-svg-icons/faShareAlt';
import '@fortawesome/pro-light-svg-icons/faSignOut';
import '@fortawesome/pro-light-svg-icons/faSlidersV';
import '@fortawesome/pro-light-svg-icons/faSlidersVSquare';
import '@fortawesome/pro-light-svg-icons/faSpinner';
import '@fortawesome/pro-light-svg-icons/faStopCircle';
import '@fortawesome/pro-light-svg-icons/faStream';
import '@fortawesome/pro-light-svg-icons/faStrikethrough';
import '@fortawesome/pro-light-svg-icons/faSync';
import '@fortawesome/pro-light-svg-icons/faTag';
import '@fortawesome/pro-light-svg-icons/faTerminal';
import '@fortawesome/pro-light-svg-icons/faThumbsDown';
import '@fortawesome/pro-light-svg-icons/faThumbsUp';
import '@fortawesome/pro-light-svg-icons/faThumbtack';
import '@fortawesome/pro-light-svg-icons/faTimes';
import '@fortawesome/pro-light-svg-icons/faTimesCircle';
import '@fortawesome/pro-light-svg-icons/faTrash';
import '@fortawesome/pro-light-svg-icons/faTypewriter';
import '@fortawesome/pro-light-svg-icons/faUnderline';
import '@fortawesome/pro-light-svg-icons/faUndo';
import '@fortawesome/pro-light-svg-icons/faUnlink';
import '@fortawesome/pro-light-svg-icons/faUser';
import '@fortawesome/pro-light-svg-icons/faUserCircle';
import '@fortawesome/pro-light-svg-icons/faUserLock';
import '@fortawesome/pro-light-svg-icons/faUserBeardBolt';
import '@fortawesome/pro-light-svg-icons/faUserRobot';
import '@fortawesome/pro-light-svg-icons/faUserSecret';
import '@fortawesome/pro-light-svg-icons/faUserAstronaut';
import '@fortawesome/pro-light-svg-icons/faUserShield';
import '@fortawesome/pro-light-svg-icons/faUsers';
import '@fortawesome/pro-light-svg-icons/faUsersCog';
import '@fortawesome/pro-light-svg-icons/faVial';
import '@fortawesome/pro-light-svg-icons/faWaveSquare';
import '@fortawesome/pro-light-svg-icons/faWifiSlash';
import '@fortawesome/pro-light-svg-icons/faWindowMinimize';
import '@fortawesome/pro-light-svg-icons/faChartBar';
import '@fortawesome/pro-light-svg-icons/faSlidersH';
import '@fortawesome/pro-light-svg-icons/faPageBreak';
import '@fortawesome/pro-light-svg-icons/faServer';
import '@fortawesome/pro-light-svg-icons/faTools';
import '@fortawesome/pro-light-svg-icons/faAnalytics';
import '@fortawesome/pro-light-svg-icons/faTrophy';
import '@fortawesome/pro-light-svg-icons/faDice';
import '@fortawesome/pro-light-svg-icons/faSwords';
import '@fortawesome/pro-light-svg-icons/faBoxingGlove';
import '@fortawesome/pro-light-svg-icons/faRandom';
import '@fortawesome/pro-light-svg-icons/faVideoPlus';
import '@fortawesome/pro-light-svg-icons/faFileAudio';
import '@fortawesome/pro-light-svg-icons/faMagic';
import '@fortawesome/pro-light-svg-icons/faSitemap';
import '@fortawesome/pro-light-svg-icons/faFiles';
import '@fortawesome/pro-light-svg-icons/faUserShakespeare';
import '@fortawesome/pro-light-svg-icons/faUserPilot';
import '@fortawesome/pro-light-svg-icons/faUserPilotTie';
import '@fortawesome/pro-light-svg-icons/faUserRobotXmarks';
import '@fortawesome/pro-light-svg-icons/faUserVisor';
import '@fortawesome/pro-light-svg-icons/faUserNinja';
import '@fortawesome/pro-light-svg-icons/faUserGear';
import '@fortawesome/pro-light-svg-icons/faArrowTurnDownRight';
import '@fortawesome/pro-light-svg-icons/faTriangleExclamation';
import '@fortawesome/pro-light-svg-icons/faMessageBot';
import '@fortawesome/pro-light-svg-icons/faVolume';
import '@fortawesome/pro-light-svg-icons/faVolumeSlash';
import '@fortawesome/pro-light-svg-icons/faImages';
import '@fortawesome/pro-light-svg-icons/faSwordLaser';
import '@fortawesome/pro-light-svg-icons/faSwordsLaser';
import '@fortawesome/pro-light-svg-icons/faHelmetBattle';
import '@fortawesome/pro-light-svg-icons/faUpRightAndDownLeftFromCenter';
import '@fortawesome/pro-light-svg-icons/faDownLeftAndUpRightToCenter';
import '@fortawesome/pro-light-svg-icons/faFileSpreadsheet';
import '@fortawesome/pro-light-svg-icons/faPresentationScreen';
import '@fortawesome/pro-light-svg-icons/faFileInvoice';
import '@fortawesome/pro-light-svg-icons/faChalkboardTeacher';
import '@fortawesome/pro-light-svg-icons/faCircleDollar';
import '@fortawesome/pro-light-svg-icons/faPersonFairy';
import '@fortawesome/pro-light-svg-icons/faCubes';
import '@fortawesome/pro-light-svg-icons/faUserHeadset';
import '@fortawesome/pro-light-svg-icons/faPalette';
import '@fortawesome/pro-light-svg-icons/faChartMixed';
import '@fortawesome/pro-light-svg-icons/faBrainCircuit';
import '@fortawesome/pro-light-svg-icons/faImageLandscape';
import '@fortawesome/pro-light-svg-icons/faHexagonPlus';
import '@fortawesome/pro-light-svg-icons/faPrintMagnifyingGlass';
import '@fortawesome/pro-light-svg-icons/faShieldHalved';
import '@fortawesome/pro-light-svg-icons/faDiagramSubtask';
import '@fortawesome/pro-light-svg-icons/faHandshake';
import '@fortawesome/pro-light-svg-icons/faBullhorn';
import '@fortawesome/pro-light-svg-icons/faCogs';
import '@fortawesome/pro-light-svg-icons/faHeadset';
import '@fortawesome/pro-light-svg-icons/faMicroscope';
import '@fortawesome/pro-light-svg-icons/faScaleBalanced';
import '@fortawesome/pro-light-svg-icons/faTruck';
import '@fortawesome/pro-light-svg-icons/faBuildings';
import '@fortawesome/pro-light-svg-icons/faInputText';
import '@fortawesome/pro-light-svg-icons/faProjectDiagram';
import '@fortawesome/pro-light-svg-icons/faPaperclip';
import '@fortawesome/pro-light-svg-icons/faFileVideo';
import '@fortawesome/pro-light-svg-icons/faCircleChevronUp';
import '@fortawesome/pro-light-svg-icons/faCircleChevronDown';
import '@fortawesome/pro-light-svg-icons/faUnlockKeyhole';
import '@fortawesome/pro-light-svg-icons/faChartScatter3d';
import '@fortawesome/pro-light-svg-icons/faSidebar';
import '@fortawesome/pro-light-svg-icons/faGlobe';
import '@fortawesome/pro-light-svg-icons/faSquare';
import '@fortawesome/pro-light-svg-icons/faSquareRss';
import '@fortawesome/pro-light-svg-icons/faAsterisk';
import '@fortawesome/pro-light-svg-icons/faCircleUser';
import '@fortawesome/pro-light-svg-icons/faUpFromBracket';
import '@fortawesome/pro-light-svg-icons/faHouseLock';
import '@fortawesome/pro-light-svg-icons/faXmarkToSlot';
import '@fortawesome/pro-light-svg-icons/faRobot';
import '@fortawesome/pro-light-svg-icons/faMagicWandSparkles';
import '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import '@fortawesome/pro-light-svg-icons/faBook';
import '@fortawesome/pro-light-svg-icons/faImagePolaroid';
import '@fortawesome/pro-light-svg-icons/faVideo';
import '@fortawesome/pro-light-svg-icons/faCube';
import '@fortawesome/pro-light-svg-icons/faToolbox';
import '@fortawesome/pro-light-svg-icons/faTimer';
import '@fortawesome/pro-light-svg-icons/faThoughtBubble';
import '@fortawesome/pro-light-svg-icons/faSwap';
import '@fortawesome/pro-light-svg-icons/faFloppyDisk';
import '@fortawesome/pro-light-svg-icons/faWandMagicSparkles';
import '@fortawesome/pro-light-svg-icons/faXmark';
import '@fortawesome/pro-light-svg-icons/faFileVector';
import '@fortawesome/pro-light-svg-icons/faWrench';
import '@fortawesome/pro-light-svg-icons/faVectorPolygon';
import '@fortawesome/pro-light-svg-icons/faClose';
import '@fortawesome/pro-light-svg-icons/faCircleXmark';
import '@fortawesome/pro-light-svg-icons/faCloud';
import '@fortawesome/pro-light-svg-icons/faPlanetMoon';
import '@fortawesome/pro-light-svg-icons/faListCheck';
import '@fortawesome/pro-light-svg-icons/faUnlock';
import '@fortawesome/pro-light-svg-icons/faCheck';
import '@fortawesome/pro-light-svg-icons/faCirclePlus';
import '@fortawesome/pro-light-svg-icons/faCircleMinus';
import '@fortawesome/pro-light-svg-icons/faWandSparkles';
import '@fortawesome/pro-light-svg-icons/faHardDrive';
import '@fortawesome/pro-light-svg-icons/faLightbulb';
import ReactPlayer from 'react-player';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { A as AppButton } from '../../dist/AppButton-a3bdb006.esm.js';
import 'react-i18next';
import '../../dist/index-0ee62650.esm.js';
import '@fortawesome/react-native-fontawesome';
import 'react-native-popable';
import 'markdown-it';
import 'mermaid';
import 'url';
import 'highlight.js';
import '@mermaid-js/mermaid-zenuml/dist/mermaid-zenuml.core.mjs';
import 'lodash-es';
import 'react-native-markdown-display';
import '../../dist/index-db6cb3b9.esm.js';
import '@react-native-picker/picker';
import '../../dist/index-5ae71f5a.esm.js';
import '../../dist/genericStyles-b9567994.esm.js';
import '../../dist/index-c2a07f56.esm.js';
import 'prop-types';
import '../../dist/index-1487832e.esm.js';
import '../../dist/index-dbc9bff8.esm.js';
import '../../dist/index-a9a6637c.esm.js';
import 'expo-linear-gradient';

function isSameDay(currentMessage, diffMessage) {
  if (!diffMessage || !diffMessage.createdAt) {
    return false;
  }
  const currentCreatedAt = dayjs(currentMessage.createdAt);
  const diffCreatedAt = dayjs(diffMessage.createdAt);

  //   using dayjs to compare the dates
  return currentCreatedAt.isSame(diffCreatedAt, "day");
}
function Day(_ref) {
  let {
    dateFormat = "",
    currentMessage,
    previousMessage,
    containerStyle,
    wrapperStyle,
    textStyle
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const styles = styleGenerator$1(currentTheme);
  if (currentMessage == null || isSameDay(currentMessage, previousMessage)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.container, containerStyle]
  }, /*#__PURE__*/React.createElement(View, {
    style: wrapperStyle
  }, /*#__PURE__*/React.createElement(AppText, {
    style: [styles.text, textStyle]
  }, dayjs(currentMessage.createdAt * 1000).format("DD MMM YY"))));
}
const styleGenerator$1 = currentTheme => {
  var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3;
  return StyleSheet.create({
    container: {
      alignItems: "center",
      justifyContent: "center",
      marginTop: 5,
      marginBottom: 10
    },
    text: {
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.transparent,
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.darkGrey,
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.extra_small_font_size,
      fontWeight: "600"
    }
  });
};
Day.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Day",
  "props": {
    "dateFormat": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "required": false
    }
  }
};

const TypingText = _ref => {
  let {
    textToDisplay = "**...**",
    delayInMilliseconds = 10,
    marginLeft,
    noDelay,
    marginTopOffset = -10,
    ...props
  } = _ref;
  const [displayText, setDisplayText] = useState("");
  const delay = noDelay ? 0 : delayInMilliseconds / textToDisplay.length;
  useEffect(() => {
    let timerId;
    for (let i = 0; i <= textToDisplay.length; i++) {
      timerId = setTimeout(() => {
        setDisplayText(textToDisplay.slice(0, i));
      }, i * delay);
    }
    return () => clearTimeout(timerId);
  }, []);
  return /*#__PURE__*/React__default.createElement(AppText, _extends({}, props, {
    wrapperStyle: {
      marginLeft
    },
    renderMarkdown: true,
    markdownStyles: {
      marginTop: marginTopOffset
    },
    showCopyButton: false
  }), displayText);
};
TypingText.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TypingText",
  "props": {
    "textToDisplay": {
      "defaultValue": {
        "value": "\"**...**\"",
        "computed": false
      },
      "required": false
    },
    "delayInMilliseconds": {
      "defaultValue": {
        "value": "10",
        "computed": false
      },
      "required": false
    },
    "marginTopOffset": {
      "defaultValue": {
        "value": "-10",
        "computed": false
      },
      "required": false
    }
  }
};

//

function getLeftIcon(leftIcon, type, AppAssets) {
  var _AppAssets$icons, _AppAssets$icons2, _AppAssets$icons3, _AppAssets$icons4, _AppAssets$icons5, _AppAssets$icons6, _AppAssets$icons7;
  if (leftIcon) {
    return leftIcon;
  }
  const iconMap = {
    audio: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons = AppAssets.icons) === null || _AppAssets$icons === void 0 ? void 0 : _AppAssets$icons.audio,
    video: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons2 = AppAssets.icons) === null || _AppAssets$icons2 === void 0 ? void 0 : _AppAssets$icons2.video,
    programming: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons3 = AppAssets.icons) === null || _AppAssets$icons3 === void 0 ? void 0 : _AppAssets$icons3.html,
    spreadsheet: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons4 = AppAssets.icons) === null || _AppAssets$icons4 === void 0 ? void 0 : _AppAssets$icons4.spreadsheet,
    document: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons5 = AppAssets.icons) === null || _AppAssets$icons5 === void 0 ? void 0 : _AppAssets$icons5.document,
    presentation: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons6 = AppAssets.icons) === null || _AppAssets$icons6 === void 0 ? void 0 : _AppAssets$icons6.presentation
  };
  return iconMap[type] || (AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons7 = AppAssets.icons) === null || _AppAssets$icons7 === void 0 ? void 0 : _AppAssets$icons7.file);
}
const ImagePreview = _ref => {
  var _window, _AppAssets$icons8, _AppAssets$icons9, _AppAssets$icons10, _currentTheme$theme, _path$split;
  let {
    path,
    workspaceid,
    S3downloadUrlRequest,
    imgStyle,
    type = "image",
    staticText,
    onPress,
    leftIcon,
    ...props
  } = _ref;
  const isElectron = !!((_window = window) !== null && _window !== void 0 && _window.electronAPI);
  const {
    currentTheme
  } = useTheme();
  const [url, setUrl] = useState(null);
  const getUrl = async () => {
    const _url = await S3downloadUrlRequest({
      workspaceid,
      logId: null,
      type: path === null || path === void 0 ? void 0 : path.split(".").pop(),
      filename: path,
      context: "pdf"
    });
    setUrl(_url === null || _url === void 0 ? void 0 : _url.url);
  };
  useEffect(() => {
    if (!path) return;
    getUrl();
  }, [path]);
  return url ? type == "image" ? /*#__PURE__*/React__default.createElement("img", _extends({
    style: {
      width: "auto",
      height: "64px",
      cursor: "pointer",
      borderRadius: 5,
      ...imgStyle
    },
    src: url,
    alt: "tf_image",
    onClick: () => {
      var _window2, _window2$electronAPI;
      if (isElectron) (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$electronAPI = _window2.electronAPI) === null || _window2$electronAPI === void 0 ? void 0 : _window2$electronAPI.downloadFileDl(url, "_blank");else window.open(url, "_blank");
    }
  }, props)) : type == "icon" ? /*#__PURE__*/React__default.createElement(AppIcon, {
    isClickable: true,
    onPress: () => {
      var _window3, _window3$electronAPI;
      if (isElectron) (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$electronAPI = _window3.electronAPI) === null || _window3$electronAPI === void 0 ? void 0 : _window3$electronAPI.downloadFileDl(url, "_blank");else window.open(url, "_blank");
    },
    icon: type == "audio" ? AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons8 = AppAssets.icons) === null || _AppAssets$icons8 === void 0 ? void 0 : _AppAssets$icons8.audio : type == "video" ? AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons9 = AppAssets.icons) === null || _AppAssets$icons9 === void 0 ? void 0 : _AppAssets$icons9.video : AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons10 = AppAssets.icons) === null || _AppAssets$icons10 === void 0 ? void 0 : _AppAssets$icons10.file
  }) : /*#__PURE__*/React__default.createElement(AppText, {
    isClickable: true,
    onPress: () => {
      var _window4, _window4$electronAPI;
      onPress ? onPress(url) : isElectron ? (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$electronAPI = _window4.electronAPI) === null || _window4$electronAPI === void 0 ? void 0 : _window4$electronAPI.downloadFileDl(url, "_blank") : window.open(url, "_blank");
    },
    style: {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.primary,
      fontWeight: "bold",
      cursor: "pointer",
      marginLeft: 5
    },
    iconSize: 16,
    leftIcon: getLeftIcon(leftIcon, type, AppAssets),
    preventTranslation: true
  }, staticText ? staticText : "".concat(path === null || path === void 0 ? void 0 : (_path$split = path.split("/")) === null || _path$split === void 0 ? void 0 : _path$split.pop())) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
};
ImagePreview.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ImagePreview",
  "props": {
    "type": {
      "defaultValue": {
        "value": "\"image\"",
        "computed": false
      },
      "required": false
    }
  }
};

const ImageGeneration = _ref => {
  let {
    _urls = [],
    selectedImage,
    onImageSelected = () => {},
    S3downloadUrlRequest,
    workspaceid
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const [urls, setUrls] = React__default.useState(null);
  // const implement a download function using the url of the image
  const downloadImage = url => {
    var link = document.createElement("a");
    link.href = url;
    link.download = "tf_image.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const getUrl = url => {
    return S3downloadUrlRequest({
      workspaceid,
      logId: null,
      type: url === null || url === void 0 ? void 0 : url.split(".").pop(),
      filename: url,
      context: "pdf"
    });
  };
  const getUrls = async _urls => {
    if (_urls && (_urls === null || _urls === void 0 ? void 0 : _urls.length) > 0) {
      const _newUrl = _urls.map(url => getUrl(url));
      const _results = await Promise.all(_newUrl);
      setUrls(_results === null || _results === void 0 ? void 0 : _results.map(result => result === null || result === void 0 ? void 0 : result.url));
    } else {
      setUrls([]);
    }
  };
  useEffect(() => {
    getUrls(_urls);
  }, [_urls]);
  return !urls || (urls === null || urls === void 0 ? void 0 : urls.length) === 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null) : /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 5
    }
  }, urls === null || urls === void 0 ? void 0 : urls.map((url, index) => {
    var _currentTheme$theme, _currentTheme$theme2, _AppAssets$icons, _currentTheme$theme3;
    return /*#__PURE__*/React__default.createElement(View, {
      key: url,
      style: {
        borderColor: selectedImage === url ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.primary : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.transparent,
        borderWidth: 2,
        height: "auto",
        width: "48%",
        cursor: "pointer",
        borderRadius: 10
      }
    }, /*#__PURE__*/React__default.createElement(View, null, /*#__PURE__*/React__default.createElement(AppIcon, {
      icon: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons = AppAssets.icons) === null || _AppAssets$icons === void 0 ? void 0 : _AppAssets$icons.download,
      onPress: () => downloadImage(url),
      wrapperStyle: {
        position: "absolute",
        right: 0,
        marginTop: 5,
        marginRight: 5,
        padding: 5,
        borderRadius: 10,
        backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.backgroundColor
      },
      size: 24,
      isClickable: true
    }), /*#__PURE__*/React__default.createElement("img", {
      key: index,
      style: {
        borderRadius: 10
      },
      src: url,
      alt: "tf_image",
      onClick: () => {
        if ((urls === null || urls === void 0 ? void 0 : urls.length) > 1) {
          if (url === selectedImage) {
            onImageSelected(null, null);
          } else onImageSelected(url, _urls[index]);
        }
      }
    })));
  }));
};
ImageGeneration.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ImageGeneration",
  "props": {
    "_urls": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false
    },
    "onImageSelected": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

const InternetSearch = _ref => {
  var _searchState$images, _searchState$videos, _searchState$shopping;
  let {
    internetSearch
  } = _ref;
  const [searchState, setSearchState] = useState(null);
  const {
    currentTheme,
    mode
  } = useTheme();
  useEffect(() => {
    if (internetSearch) setSearchState(generateState(internetSearch));
  }, [internetSearch]);
  const generateState = internetSearch => {
    const videos = internetSearch === null || internetSearch === void 0 ? void 0 : internetSearch.filter(u => {
      return u.tf_type === "videos";
    });
    const images = internetSearch === null || internetSearch === void 0 ? void 0 : internetSearch.filter(u => {
      return u.tf_type === "images";
    });
    const news = internetSearch === null || internetSearch === void 0 ? void 0 : internetSearch.filter(u => {
      return u.tf_type === "news";
    });
    const shopping = internetSearch === null || internetSearch === void 0 ? void 0 : internetSearch.filter(u => {
      return u.tf_type === "shopping";
    });
    const organic = internetSearch === null || internetSearch === void 0 ? void 0 : internetSearch.filter(u => {
      return u.tf_type === "search";
    });
    return {
      videos,
      images,
      news,
      shopping,
      organic
    };
  };
  return /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      marginTop: 10,
      marginBottom: 10,
      gap: 5
    }
  }, searchState === null || searchState === void 0 ? void 0 : (_searchState$images = searchState.images) === null || _searchState$images === void 0 ? void 0 : _searchState$images.map((image, index) => {
    return /*#__PURE__*/React__default.createElement("img", {
      key: image === null || image === void 0 ? void 0 : image.link,
      style: {
        width: "auto",
        height: "64px",
        cursor: "pointer",
        borderRadius: 10
      },
      src: image === null || image === void 0 ? void 0 : image.thumbnailUrl,
      alt: "tf_image",
      onClick: () => {
        window.open(image === null || image === void 0 ? void 0 : image.link, "_blank");
      }
    });
  }), searchState === null || searchState === void 0 ? void 0 : (_searchState$videos = searchState.videos) === null || _searchState$videos === void 0 ? void 0 : _searchState$videos.map((video, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "video-container",
      onClick: () => {
        window.open(video === null || video === void 0 ? void 0 : video.link, "_blank");
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      key: video === null || video === void 0 ? void 0 : video.link,
      style: {
        width: "auto",
        height: "64px",
        cursor: "pointer",
        borderRadius: 10
      },
      src: video === null || video === void 0 ? void 0 : video.imageUrl,
      alt: "tf_image"
    }));
  }), searchState === null || searchState === void 0 ? void 0 : (_searchState$shopping = searchState.shopping) === null || _searchState$shopping === void 0 ? void 0 : _searchState$shopping.map((shop, index) => {
    var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4, _currentTheme$theme5, _currentTheme$theme6, _currentTheme$theme7, _currentTheme$theme8;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "shop-container",
      onClick: () => {
        window.open(shop === null || shop === void 0 ? void 0 : shop.link, "_blank");
      },
      style: {
        border: "1px solid ".concat(currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.border_color)
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      key: shop === null || shop === void 0 ? void 0 : shop.link,
      style: {
        cursor: "pointer",
        borderRadius: 10
      },
      src: shop === null || shop === void 0 ? void 0 : shop.imageUrl,
      alt: "tf_image",
      className: "shop-image"
    }), /*#__PURE__*/React__default.createElement(View, {
      style: {
        paddingHorizontal: 5
      }
    }, /*#__PURE__*/React__default.createElement(AppText, {
      onPress: () => {
        window.open(shop === null || shop === void 0 ? void 0 : shop.link, "_blank");
      },
      isClickable: true,
      isHoverable: false,
      wrapperStyle: {
        borderTopColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.primary_medium,
        borderBottomColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.primary_medium,
        borderBottomWidth: 1,
        borderTopWidth: 1,
        paddingVertical: 5,
        marginVertical: 5,
        cursor: "pointer",
        paddingHorizontal: 5
      },
      style: {
        fontColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.primary,
        fontWeight: "bold"
      }
    }, shop === null || shop === void 0 ? void 0 : shop.title), /*#__PURE__*/React__default.createElement("span", {
      style: {
        fontFamily: "normalFont",
        fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.base_font_size,
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.font_color,
        paddingLeft: 5
      }
    }, "Price - ", /*#__PURE__*/React__default.createElement("strong", null, shop === null || shop === void 0 ? void 0 : shop.price)), /*#__PURE__*/React__default.createElement("span", {
      style: {
        fontFamily: "normalFont",
        fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.base_font_size,
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.font_color,
        paddingLeft: 5
      }
    }, /*#__PURE__*/React__default.createElement("strong", null, shop === null || shop === void 0 ? void 0 : shop.delivery))));
  }));
};
InternetSearch.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InternetSearch"
};

const VideoThumbnail = _ref => {
  let {
    videoUrl,
    handleClick = () => {}
  } = _ref;
  const [thumbnail, setThumbnail] = useState(null);
  const handleReady = player => {
    const canvas = document.createElement("canvas");
    canvas.width = player.getInternalPlayer().videoWidth;
    canvas.height = player.getInternalPlayer().videoHeight;
    canvas.getContext("2d").drawImage(player.getInternalPlayer(), 0, 0);
    setThumbnail(canvas.toDataURL());
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "relative",
      display: "inline-block",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(ReactPlayer, {
    url: videoUrl,
    width: "0",
    height: "0",
    onReady: handleReady,
    config: {
      file: {
        attributes: {
          crossOrigin: "anonymous"
        }
      }
    }
  }), thumbnail && /*#__PURE__*/React__default.createElement("div", {
    onClick: handleClick,
    style: {
      position: "relative",
      cursor: "pointer"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    style: {
      borderRadius: 10,
      width: "100%",
      display: "block"
    },
    src: thumbnail,
    alt: "Video thumbnail"
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "60px",
      height: "60px",
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: 0,
      height: 0,
      borderTop: "15px solid transparent",
      borderBottom: "15px solid transparent",
      borderLeft: "25px solid white",
      marginLeft: "5px"
    }
  }))));
};
VideoThumbnail.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VideoThumbnail",
  "props": {
    "handleClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

const VideoGeneration = _ref => {
  let {
    _urls = [],
    selectedVideo = null,
    onVideoSelected = () => {},
    S3downloadUrlRequest,
    workspaceid
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const [urls, setUrls] = React__default.useState(null);
  const [playing, setPlaying] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);

  // Implement a download function using the url of the video
  const downloadVideo = url => {
    var link = document.createElement("a");
    link.href = url;
    link.download = "tf_video.mp4";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const getUrl = url => {
    return S3downloadUrlRequest({
      workspaceid,
      logId: null,
      type: url === null || url === void 0 ? void 0 : url.split(".").pop(),
      filename: url,
      context: "pdf"
    });
  };
  const getUrls = async _urls => {
    if (_urls && (_urls === null || _urls === void 0 ? void 0 : _urls.length) > 0) {
      const _newUrl = _urls.map(url => getUrl(url));
      const _results = await Promise.all(_newUrl);
      setUrls(_results === null || _results === void 0 ? void 0 : _results.map(result => result === null || result === void 0 ? void 0 : result.url));
    } else {
      setUrls([]);
    }
  };
  useEffect(() => {
    getUrls(_urls);
  }, [_urls]);
  const handleVideoClick = (url, index) => {
    if ((urls === null || urls === void 0 ? void 0 : urls.length) > 1) {
      if (url === selectedVideo) {
        onVideoSelected(null, null);
      } else {
        onVideoSelected(url, _urls[index]);
        setVideoUrl(url);
        setPlaying(true);
      }
    }
  };
  return !urls || (urls === null || urls === void 0 ? void 0 : urls.length) === 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null) : /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "column",
      flexWrap: "wrap",
      gap: 5
    }
  }, urls === null || urls === void 0 ? void 0 : urls.map((url, index) => {
    var _currentTheme$theme, _currentTheme$theme2;
    if (index == 1) return /*#__PURE__*/React__default.createElement(View, {
      key: url,
      style: {
        borderColor: selectedVideo === url ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.primary : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.transparent,
        borderWidth: 2,
        height: "auto",
        width: "98%",
        cursor: "pointer",
        borderRadius: 10
      }
    }, /*#__PURE__*/React__default.createElement(View, null, playing && videoUrl === url ? /*#__PURE__*/React__default.createElement("video", {
      key: index,
      style: {
        borderRadius: 10,
        width: "100%",
        height: "100%"
      },
      src: url,
      controls: true,
      autoPlay: true
    }) : /*#__PURE__*/React__default.createElement(VideoThumbnail, {
      videoUrl: url,
      handleClick: () => handleVideoClick(url, index),
      key: index
    })));
  }),
  /*#__PURE__*/
  // create 2 links to download the 2 videos
  React__default.createElement(View, {
    style: {
      flexDirection: "column",
      gap: 5,
      justifyContent: "space-between",
      marginTop: 10,
      alignSelf: "flex-end",
      marginRight: 20
    }
  }, urls === null || urls === void 0 ? void 0 : urls.map((url, index) => {
    var _currentTheme$theme3;
    return /*#__PURE__*/React__default.createElement(AppText, {
      style: {
        fontWeight: "bold",
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.textColor,
        textAlign: "right"
      },
      isClickable: true,
      onPress: () => {
        downloadVideo(url);
      },
      key: "tf_download_".concat(index)
    }, "".concat(index == 0 ? "🔇" : "🔉", " Download video with").concat(index == 0 ? "out " : " ", "audio"));
  })));
};
VideoGeneration.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VideoGeneration",
  "props": {
    "_urls": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false
    },
    "selectedVideo": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "onVideoSelected": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

const ThreeDModelViewer = _ref => {
  let {
    _urls,
    videoUrl,
    imageUrl,
    onModelSelected,
    S3downloadUrlRequest,
    workspaceid
  } = _ref;
  const mountRef = useRef(null);
  const [urls, setUrls] = React__default.useState(null);
  const rendererRef = useRef(null);
  const sceneRef = useRef(null);
  let handleResize = null;
  const getUrl = url => {
    return S3downloadUrlRequest({
      workspaceid,
      logId: null,
      type: url === null || url === void 0 ? void 0 : url.split(".").pop(),
      filename: url,
      context: "pdf"
    });
  };
  const getUrls = async _urls => {
    if (_urls && (_urls === null || _urls === void 0 ? void 0 : _urls.length) > 0) {
      const _newUrl = _urls.map(url => getUrl(url));
      const _results = await Promise.all(_newUrl);
      setUrls(_results === null || _results === void 0 ? void 0 : _results.map(result => result === null || result === void 0 ? void 0 : result.url));
    } else {
      setUrls([]);
    }
  };
  useEffect(() => {
    getUrls(_urls);
  }, [_urls]);
  useEffect(() => {
    if (urls && (urls === null || urls === void 0 ? void 0 : urls.length) > 0) {
      // Scene setup
      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
      const renderer = new THREE.WebGLRenderer({
        antialias: true
      });
      rendererRef.current = renderer; // Store renderer in ref
      renderer.setSize(window.innerWidth, window.innerHeight);
      renderer.setClearColor(0xffffff, 1);
      mountRef.current.appendChild(renderer.domElement);

      // Lighting
      // Lighting
      // Increase ambient light intensity
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.8); // Increased from 0.5 to 0.8
      scene.add(ambientLight);

      // Increase directional light intensity and add more directional lights
      const directionalLight1 = new THREE.DirectionalLight(0xffffff, 1);
      directionalLight1.position.set(1, 1, 1);
      scene.add(directionalLight1);
      const directionalLight2 = new THREE.DirectionalLight(0xffffff, 0.8);
      directionalLight2.position.set(-1, -1, -1);
      scene.add(directionalLight2);

      // Add a point light to highlight details
      const pointLight = new THREE.PointLight(0xffffff, 1, 100);
      pointLight.position.set(0, 10, 0);
      scene.add(pointLight);
      sceneRef.current = scene; // Store scene in ref
      // Controls
      const controls = new OrbitControls(camera, renderer.domElement);
      controls.enableDamping = true;
      controls.dampingFactor = 0.25;
      controls.enableZoom = true;
      const fitCameraToObject = function (object) {
        let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.25;
        const boundingBox = new THREE.Box3().setFromObject(object);
        const center = boundingBox.getCenter(new THREE.Vector3());
        const size = boundingBox.getSize(new THREE.Vector3());
        const maxDim = Math.max(size.x, size.y, size.z);
        const fov = camera.fov * (Math.PI / 180);
        let cameraZ = Math.abs(maxDim / 2 / Math.tan(fov / 2)) * offset;
        camera.position.z = cameraZ;
        const minZ = boundingBox.min.z;
        const cameraToFarEdge = minZ < 0 ? -minZ + cameraZ : cameraZ - minZ;
        camera.far = cameraToFarEdge * 3;
        camera.updateProjectionMatrix();
        if (controls) {
          controls.target.copy(center);
          controls.maxDistance = cameraToFarEdge * 2;
        }
      };
      // Load 3D model
      const loader = new GLTFLoader();
      loader.load(urls[0], gltf => {
        scene.add(gltf.scene);
        // camera.position.z = 5;
        fitCameraToObject(gltf.scene);

        // Traverse the loaded model and adjust materials if needed
        gltf.scene.traverse(child => {
          if (child.isMesh) {
            // Increase the metalness and roughness to enhance detail visibility
            if (child.material.metalness !== undefined) {
              child.material.metalness = 0.5;
            }
            if (child.material.roughness !== undefined) {
              child.material.roughness = 0.7;
            }
            // Ensure the material updates
            child.material.needsUpdate = true;
          }
        });
      }, undefined, error => console.error("An error occurred loading the model:", error));

      // Animation loop
      const animate = () => {
        requestAnimationFrame(animate);
        controls.update();
        renderer.render(scene, camera);
      };
      animate();
      // Resize handler
      handleResize = () => {
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(window.innerWidth, window.innerHeight);
      };
      window.addEventListener("resize", handleResize);
    }
    return () => {
      if (handleResize) {
        window.removeEventListener("resize", handleResize);
      }
      if (mountRef.current && rendererRef.current) {
        mountRef.current.removeChild(rendererRef.current.domElement);
      }
      try {
        var _rendererRef$current, _sceneRef$current;
        // Dispose of Three.js objects
        rendererRef === null || rendererRef === void 0 ? void 0 : (_rendererRef$current = rendererRef.current) === null || _rendererRef$current === void 0 ? void 0 : _rendererRef$current.dispose();
        sceneRef === null || sceneRef === void 0 ? void 0 : (_sceneRef$current = sceneRef.current) === null || _sceneRef$current === void 0 ? void 0 : _sceneRef$current.dispose();
      } catch (e) {
        console.log(e);
      }
    };
  }, [urls]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    ref: mountRef
  }));
};
ThreeDModelViewer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ThreeDModelViewer"
};

function containsMarkdownLink(markdownString) {
  // Regular expression to match Markdown links
  const markdownLinkRegex = /\[([^\]]+)\]\(([^)]+)\)/;

  // Test if the markdown string contains a link
  return markdownLinkRegex.test(markdownString);
}
function attemptConversionOfExtensionToType(ext) {
  if (!ext) return "file";else if (ext === "jpg" || ext === "jpeg" || ext === "png" || ext === "gif") return "image";else if (ext === "mp4" || ext === "mov" || ext === "avi" || ext === "mkv") return "video";else if (ext === "mp3" || ext === "wav" || ext === "aac" || ext === "flac") return "audio";else if (["html", "js", "css", "json", "xml", "sql", "sh", "php", "ts", "tsx", "jsx", "csharp", "rb"].includes(ext)) return "programming";else if (["csv", "tsv", "xlsx", "xls", "ods", "dbf", "sav", "dta", "sas7bdat", "parquet"].includes(ext)) return "spreadsheet";else if (["pdf", "doc", "docx", "odt", "rtf", "tex", "txt"].includes(ext)) return "document";else if (["pptx", "ppt"].includes(ext)) return "presentation";else return "file";
}
function hexToRGB(hex, alpha) {
  try {
    if (!hex) return hex;
    // check if it is a hex
    if (!(hex !== null && hex !== void 0 && hex.startsWith("#"))) {
      // just change the opacity of the color to 0.1 assuming the source is rgba only
      const rgb = hex.split("(")[1].split(")")[0].split(",");
      return "rgba(".concat(rgb[0], ", ").concat(rgb[1], ", ").concat(rgb[2], ", ").concat(alpha, ")");
    }
    let expandedHex = hex;
    if (hex.length === 4) {
      expandedHex = "#" + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
    }
    const r = parseInt(expandedHex.slice(1, 3), 16);
    const g = parseInt(expandedHex.slice(3, 5), 16);
    const b = parseInt(expandedHex.slice(5, 7), 16);
    if (alpha) {
      return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
    } else {
      return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
    }
  } catch (error) {
    return hex;
  }
}
const mapStateWithLabel = state => {
  switch (state) {
    case "data_processing_completed":
      return "**Retrieving data**";
    case "tools_processing_completed":
      return "**Choosing tools**";
    case "replying":
      return "**Responding**";
    case "memory_updated":
      return "Memory updated";
    default:
      return "";
  }
};
const AppQuantumChat = _ref2 => {
  var _chatBoxRef$current, _ref$_listRef, _currentTheme$theme, _currentTheme$theme2, _props$messages, _props$messages$filte, _chatBoxRef$current2, _messages2, _messages2$text, _currentTheme$theme53, _currentTheme$theme54;
  let {
    maxInputLength = 1000,
    textInputPlaceholder = "Ask me anything...",
    messages = [],
    setMessages,
    user,
    chatStyle,
    onSendEvent = () => {},
    onCopy = () => {},
    loadEarlier = true,
    showAvatarForEveryMessage = true,
    showUserAvatar = true,
    alwaysShowSend = true,
    isTimeDisplayed = true,
    sendOnEnter = false,
    renderSendIcon = true,
    isDayDisplayed = true,
    noDelay = false,
    isWebsite = false,
    showIconOnInputLeft = false,
    textColor = "font_color",
    containerHeight,
    placeholderDisabled = "Let me think...",
    placeholder = "Ask me anything...",
    messagesContainerStyle,
    composerHeight,
    sortOrder = "desc",
    textToDisplayWhileLoading = "**...**",
    delayInMilliseconds = 10,
    suppressDisabledPlaceholder = false,
    allowUserToTypeWhileGeneratingResponse = false,
    onCancel = () => {},
    inputText,
    setInputText,
    renderWithVanillaInput = true,
    children,
    renderMarkdown = false,
    agentDefaultIcon,
    S3downloadUrlRequest = () => {},
    handleShowSourcesDetails = () => {},
    workspaceid,
    showIconForGenericUser = false,
    agentColor,
    allowFeedback = false,
    handleFeedback = () => {},
    showDuration = false,
    showRoutedModel = false,
    showLanguage = false,
    rlhf = false,
    isWidget = false,
    disableEditingFeedback = false,
    coder = false,
    chatid = null,
    customChartingConfig = null,
    scrollToBottom = false,
    showSplash = false,
    splashTitle = "Hi, how can I help?",
    showAgentName = false,
    showProcessingMetadata = false,
    onImageSelected = () => {},
    onVideoSelected = () => {},
    listenToAudio = () => {},
    selectedImageKey,
    isSpeechGettingProcessed = false,
    updateTextForSpeech,
    showTextToSpeech = false,
    showCodeInExecution = true,
    plannerMode = false,
    showLoading = true,
    cursor = "",
    renderHTMLLinkPreview = true,
    hideReasoning = false,
    scrollThreshold = 0.05,
    requiresApproval = false,
    sendApprovalMessage = () => {},
    ...props
  } = _ref2;
  const {
    currentTheme,
    mode
  } = useTheme();
  const styles = styleGenerator(currentTheme, isWebsite, textColor);
  const [isFullyScrolledOnLoad, setIsFullyScrolledOnLoad] = useState(false);
  const endOfMessagesRef = useRef(null);
  const chatBoxRef = useRef(null);
  const [isLoadingEarlier, setIsLoadingEarlier] = useState(false);
  const isScrollingManually = useRef(false);
  const _ref = chatBoxRef === null || chatBoxRef === void 0 ? void 0 : (_chatBoxRef$current = chatBoxRef.current) === null || _chatBoxRef$current === void 0 ? void 0 : _chatBoxRef$current._messageContainerRef.current;
  useRef(_ref === null || _ref === void 0 ? void 0 : (_ref$_listRef = _ref._listRef) === null || _ref$_listRef === void 0 ? void 0 : _ref$_listRef._scrollRef);
  const prevOffsetRef = useRef(null);
  // const scrollViewRef = useRef(null);
  const _appLogo = /*#__PURE__*/React__default.createElement(AppIcon, {
    style: {
      paddingTop: 10,
      paddingBottom: 0,
      paddingRight: 5,
      width: 26,
      marginLeft: 0,
      borderRadius: 20
    },
    imageSource: agentDefaultIcon,
    width: "100%",
    size: 24
  });
  const _splashLogo = showSplash ? /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "column",
      alignItems: "center",
      zIndex: 10,
      position: "relative",
      transform: "inherit",
      alignSelf: "center",
      margin: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    style: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingRight: 5,
      width: 48,
      marginLeft: 0,
      borderRadius: 20
    },
    imageSource: agentDefaultIcon,
    width: "100%",
    size: 48
  }), /*#__PURE__*/React__default.createElement(AppText, {
    style: {
      fontWeight: "bold",
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.medium_font_size,
      marginHorizontal: 20
    },
    color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.darkGrey
  }, splashTitle)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  const isMessageInProcess = (props === null || props === void 0 ? void 0 : (_props$messages = props.messages) === null || _props$messages === void 0 ? void 0 : (_props$messages$filte = _props$messages.filter(message => message === null || message === void 0 ? void 0 : message.loading)) === null || _props$messages$filte === void 0 ? void 0 : _props$messages$filte.length) > 0;
  const CustomSend = props => {
    var _AppAssets$icons, _AppAssets$icons2, _currentTheme$theme3;
    return renderSendIcon ? /*#__PURE__*/React__default.createElement(Send, props, /*#__PURE__*/React__default.createElement(View, {
      style: styles.sendButtonContainer
    }, /*#__PURE__*/React__default.createElement(AppIcon, {
      icon: props.isComposerDisabled ? AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons = AppAssets.icons) === null || _AppAssets$icons === void 0 ? void 0 : _AppAssets$icons.close : AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons2 = AppAssets.icons) === null || _AppAssets$icons2 === void 0 ? void 0 : _AppAssets$icons2.answer_icon,
      color: props.isComposerDisabled && (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.red),
      size: 20,
      wrapperStyle: {
        marginRight: 0,
        marginLeft: 8,
        marginTop: -25,
        justifyContent: "center"
      },
      isClickable: props.isComposerDisabled,
      onPress: onCancel
    }))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  };
  const handleQuickApprovePlanner = msg_id => {
    if (requiresApproval) {
      sendApprovalMessage("Approved", msg_id);
    }
  };
  const renderInputToolbar = props => {
    return /*#__PURE__*/React__default.createElement(InputToolbar, _extends({}, props, {
      containerStyle: styles.inputToolbarStyle,
      primaryStyle: {
        alignItems: "top"
      },
      renderSend: sendProps => /*#__PURE__*/React__default.createElement(CustomSend, sendProps),
      renderComposer: composerProps => {
        var _AppAssets$icons3;
        return /*#__PURE__*/React__default.createElement(AppFadeView, {
          style: {
            flexDirection: "row",
            alignItems: "center",
            flex: 1
          },
          duration: 1000
        }, showIconOnInputLeft && /*#__PURE__*/React__default.createElement(AppIcon, {
          icon: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons3 = AppAssets.icons) === null || _AppAssets$icons3 === void 0 ? void 0 : _AppAssets$icons3.arrow_right,
          size: 16,
          wrapperStyle: {
            marginRight: 0,
            marginLeft: 8,
            marginTop: -8,
            justifyContent: "center"
          }
        }), /*#__PURE__*/React__default.createElement(CustomComposer, composerProps));
      }
    }));
  };
  const mapNameToInitials = name => {
    if (name == "assistant") return "ToothFairy Agent Reply";else if (name === "system") return "ToothFairy Agent Setup";else return name;
  };
  const renderAvatar = props => {
    var _props$currentMessage, _props$currentMessage2, _props$currentMessage3, _props$currentMessage4, _props$currentMessage5, _props$currentMessage6, _props$currentMessage7, _props$currentMessage8, _props$currentMessage9, _props$currentMessage10, _AppAssets$icons4, _currentTheme$theme4;
    const name = mapNameToInitials(props === null || props === void 0 ? void 0 : (_props$currentMessage = props.currentMessage) === null || _props$currentMessage === void 0 ? void 0 : (_props$currentMessage2 = _props$currentMessage.user) === null || _props$currentMessage2 === void 0 ? void 0 : _props$currentMessage2.name);
    if (!showUserAvatar) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
    if ((props === null || props === void 0 ? void 0 : (_props$currentMessage3 = props.currentMessage) === null || _props$currentMessage3 === void 0 ? void 0 : (_props$currentMessage4 = _props$currentMessage3.user) === null || _props$currentMessage4 === void 0 ? void 0 : (_props$currentMessage5 = _props$currentMessage4.name) === null || _props$currentMessage5 === void 0 ? void 0 : _props$currentMessage5.toLowerCase()) === "assistant" || (props === null || props === void 0 ? void 0 : (_props$currentMessage6 = props.currentMessage) === null || _props$currentMessage6 === void 0 ? void 0 : (_props$currentMessage7 = _props$currentMessage6.user) === null || _props$currentMessage7 === void 0 ? void 0 : _props$currentMessage7.id) === "planner") return _appLogo;else if ((props === null || props === void 0 ? void 0 : (_props$currentMessage8 = props.currentMessage) === null || _props$currentMessage8 === void 0 ? void 0 : (_props$currentMessage9 = _props$currentMessage8.user) === null || _props$currentMessage9 === void 0 ? void 0 : (_props$currentMessage10 = _props$currentMessage9.name) === null || _props$currentMessage10 === void 0 ? void 0 : _props$currentMessage10.toLowerCase()) === "user" && showIconForGenericUser) return /*#__PURE__*/React__default.createElement(AppIcon, {
      icon: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons4 = AppAssets.icons) === null || _AppAssets$icons4 === void 0 ? void 0 : _AppAssets$icons4.userEnhanced,
      size: 18,
      wrapperStyle: {
        alignSelf: "center",
        marginTop: 8
      },
      color: agentColor || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.primary)
    });else return /*#__PURE__*/React__default.createElement(AppAvatar, {
      style: {
        alignSelf: "center",
        marginTop: 8
      },
      ratio: 0.45,
      label: name,
      size: 24
    });
  };
  useEffect(() => {
    setIsFullyScrolledOnLoad(false);
  }, [chatid]);
  useEffect(() => {
    if (props !== null && props !== void 0 && props.isComposerDisabled) setTimeout(() => {
      isScrollingManually.current = false;
    }, 100);
  }, [props === null || props === void 0 ? void 0 : props.isComposerDisabled]);
  useEffect(() => {
    const isNearBottom = true;
    if (!isFullyScrolledOnLoad && _ref) {
      setIsFullyScrolledOnLoad(true);
      const scrollToEndIfAllowed = () => {
        if (!(props !== null && props !== void 0 && props.isComposerDisabled) && !isScrollingManually.current) {
          _ref === null || _ref === void 0 ? void 0 : _ref.scrollToEnd(true);
        }
      };
      const scrollWithDelays = () => {
        scrollToEndIfAllowed();
        setTimeout(scrollToEndIfAllowed, 100);
        setTimeout(scrollToEndIfAllowed, 200);
      };
      setTimeout(scrollWithDelays, 100);
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && isNearBottom && !isScrollingManually.current && props !== null && props !== void 0 && props.isComposerDisabled) {
          _ref.scrollToEnd(true);
        }
      });
    }, {
      threshold: 0.1
    });
    if (endOfMessagesRef.current) {
      observer.observe(endOfMessagesRef.current);
    }

    // Cleanup
    return () => {
      if (endOfMessagesRef.current) {
        observer.unobserve(endOfMessagesRef.current);
      }
    };
  }, [isFullyScrolledOnLoad, isScrollingManually === null || isScrollingManually === void 0 ? void 0 : isScrollingManually.current, // chatBoxRef?.current?._messageContainerRef.current?._listRef?._scrollRef,
  chatBoxRef === null || chatBoxRef === void 0 ? void 0 : (_chatBoxRef$current2 = chatBoxRef.current) === null || _chatBoxRef$current2 === void 0 ? void 0 : _chatBoxRef$current2._messageContainerRef.current, JSON.stringify(messages ? messages[(messages === null || messages === void 0 ? void 0 : messages.length) - 1] : [])]);
  const CustomComposer = props => {
    var _currentTheme$theme5, _currentTheme$theme6;
    const handleKeyPress = e => {
      if (e.nativeEvent.key === "Enter" && !e.nativeEvent.shiftKey && sendOnEnter) {
        e.preventDefault();
        props.onSend({
          text: props.text.trim()
        }, true);
        // textInputRef.current.focus();
      }
    };

    return /*#__PURE__*/React__default.createElement(Composer, _extends({}, props, {
      disableComposer: (isMessageInProcess || props.isComposerDisabled) && !allowUserToTypeWhileGeneratingResponse,
      placeholderTextColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.bubble_placeholder,
      textInputAutoFocus: true,
      textInputStyle: {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.theme[textColor],
        fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.small_font_size,
        fontFamily: "normalFont",
        flex: 1
      },
      composerHeight: composerHeight,
      placeholder: (isMessageInProcess || props.isComposerDisabled) && !suppressDisabledPlaceholder ? placeholderDisabled : placeholder,
      textInputProps: {
        onKeyPress: handleKeyPress
      }
    }));
  };
  const renderTime = props => {
    var _currentTheme$theme7;
    return isTimeDisplayed ? /*#__PURE__*/React__default.createElement(AppText, {
      style: {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.theme[textColor],
        fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.extra_small_font_size,
        fontWeight: "400",
        lineHeight: 10
      },
      wrapperStyle: {
        marginTop: 6,
        justifyContent: isWidget && "flex-end",
        width: isWidget && "100%"
      }
    }, props.currentMessage.createdAt ? dayjs(props.currentMessage.createdAt * 1000).format("H:mm A") : "") : /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  };
  const renderLoadEarlier = props => {
    var _currentTheme$theme8, _currentTheme$theme9, _currentTheme$theme10;
    const {
      currentTheme
    } = useTheme();
    return /*#__PURE__*/React__default.createElement(AppFadeView, {
      style: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 10
      },
      duration: 1000
    }, /*#__PURE__*/React__default.createElement(AppText, {
      style: {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.primary,
        fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme9 = currentTheme.theme) === null || _currentTheme$theme9 === void 0 ? void 0 : _currentTheme$theme9.small_font_size,
        fontWeight: "400",
        lineHeight: 10,
        backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme10 = currentTheme.theme) === null || _currentTheme$theme10 === void 0 ? void 0 : _currentTheme$theme10.transparent,
        padding: 10,
        borderRadius: 10
      },
      isClickable: true,
      isHoverable: false,
      onPress: () => {
        var _chatBoxRef$current3, _chatBoxRef$current3$, _chatBoxRef$current3$2, _chatBoxRef$current3$3, _chatBoxRef$current3$4;
        setIsLoadingEarlier(true);
        setIsFullyScrolledOnLoad(true);
        setTimeout(() => {
          props.onLoadEarlier();
        }, 500);
        chatBoxRef === null || chatBoxRef === void 0 ? void 0 : (_chatBoxRef$current3 = chatBoxRef.current) === null || _chatBoxRef$current3 === void 0 ? void 0 : (_chatBoxRef$current3$ = _chatBoxRef$current3._messageContainerRef) === null || _chatBoxRef$current3$ === void 0 ? void 0 : (_chatBoxRef$current3$2 = _chatBoxRef$current3$.current) === null || _chatBoxRef$current3$2 === void 0 ? void 0 : (_chatBoxRef$current3$3 = _chatBoxRef$current3$2._listRef) === null || _chatBoxRef$current3$3 === void 0 ? void 0 : (_chatBoxRef$current3$4 = _chatBoxRef$current3$3._scrollRef) === null || _chatBoxRef$current3$4 === void 0 ? void 0 : _chatBoxRef$current3$4.scrollTo({
          x: 5,
          y: 5,
          animated: true
        });
        setTimeout(() => {
          var _chatBoxRef$current4, _chatBoxRef$current4$, _chatBoxRef$current4$2, _chatBoxRef$current4$3, _chatBoxRef$current4$4;
          setIsLoadingEarlier(false);
          chatBoxRef === null || chatBoxRef === void 0 ? void 0 : (_chatBoxRef$current4 = chatBoxRef.current) === null || _chatBoxRef$current4 === void 0 ? void 0 : (_chatBoxRef$current4$ = _chatBoxRef$current4._messageContainerRef) === null || _chatBoxRef$current4$ === void 0 ? void 0 : (_chatBoxRef$current4$2 = _chatBoxRef$current4$.current) === null || _chatBoxRef$current4$2 === void 0 ? void 0 : (_chatBoxRef$current4$3 = _chatBoxRef$current4$2._listRef) === null || _chatBoxRef$current4$3 === void 0 ? void 0 : (_chatBoxRef$current4$4 = _chatBoxRef$current4$3._scrollRef) === null || _chatBoxRef$current4$4 === void 0 ? void 0 : _chatBoxRef$current4$4.scrollTo({
            x: 5,
            y: 5,
            animated: true
          });
        }, 1000);
      }
    }, "Load previous messages"));
  };
  // added to prevent scrolling with mermaid charts
  useEffect(() => {
    var _messages, _messages$text, _chatBoxRef$current5;
    const isMermaid = (_messages = messages[(messages === null || messages === void 0 ? void 0 : messages.length) - 1]) === null || _messages === void 0 ? void 0 : (_messages$text = _messages.text) === null || _messages$text === void 0 ? void 0 : _messages$text.includes("mermaid");
    setIsFullyScrolledOnLoad(isMermaid);
    const _ref = chatBoxRef === null || chatBoxRef === void 0 ? void 0 : (_chatBoxRef$current5 = chatBoxRef.current) === null || _chatBoxRef$current5 === void 0 ? void 0 : _chatBoxRef$current5._messageContainerRef.current;
    if (isMermaid && _ref) {
      _ref.scrollEnabled = false;
    } else if (_ref) {
      _ref.scrollEnabled = true;
    }
  }, [messages && ( // condition disabled for now
  // messages?.length < 3 &&
  (_messages2 = messages[(messages === null || messages === void 0 ? void 0 : messages.length) - 1]) === null || _messages2 === void 0 ? void 0 : (_messages2$text = _messages2.text) === null || _messages2$text === void 0 ? void 0 : _messages2$text.includes("mermaid"))]);
  const renderBubble = props => {
    if (showLoading && props.currentMessage.loading) {
      var _currentTheme$theme11, _currentTheme$theme12, _props$currentMessage11, _props$currentMessage12, _currentTheme$theme13, _currentTheme$theme14, _props$currentMessage13, _props$currentMessage14;
      return /*#__PURE__*/React__default.createElement(AppFadeView, {
        duration: 500,
        style: {
          flexDirection: "row",
          alignSelf: "flex-start",
          justifyContent: "space-between",
          marginLeft: 0,
          position: !isWebsite && "absolute",
          left: !isWebsite && 10,
          width: "100%",
          height: 60,
          maxHeight: 60
        }
      }, /*#__PURE__*/React__default.createElement(View, {
        style: {
          flexDirection: "row",
          alignItems: "center"
        }
      }, /*#__PURE__*/React__default.createElement(AppActivityIndicator, {
        visible: true,
        size: 20,
        containerStyle: {
          alignSelf: "flex-start",
          marginLeft: isWebsite ? 0 : 10,
          marginTop: props.renderAvatarOnTop && 7
        },
        endColor: agentColor || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme11 = currentTheme.theme) === null || _currentTheme$theme11 === void 0 ? void 0 : _currentTheme$theme11.primary)
      }), /*#__PURE__*/React__default.createElement(TypingText, {
        style: {
          color: currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.theme[textColor],
          fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme12 = currentTheme.theme) === null || _currentTheme$theme12 === void 0 ? void 0 : _currentTheme$theme12.small_font_size,
          fontWeight: "400",
          lineHeight: 18,
          marginLeft: 2,
          marginTop: props.renderAvatarOnTop && 5
        },
        marginLeft: isWebsite ? 10 : 0,
        delayInMilliseconds: delayInMilliseconds,
        textToDisplay: textToDisplayWhileLoading,
        noDelay: noDelay,
        marginTopOffset: isWidget ? 0 : -10
      })), showProcessingMetadata && ["memory_updated"].includes(props === null || props === void 0 ? void 0 : (_props$currentMessage11 = props.currentMessage) === null || _props$currentMessage11 === void 0 ? void 0 : (_props$currentMessage12 = _props$currentMessage11.metadata) === null || _props$currentMessage12 === void 0 ? void 0 : _props$currentMessage12.agent_processing_status) && /*#__PURE__*/React__default.createElement(AppText, {
        wrapperStyle: {
          marginTop: 2,
          marginRight: 15,
          alignSelf: "flex-end",
          minHeight: 20
        },
        style: {
          fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme13 = currentTheme.theme) === null || _currentTheme$theme13 === void 0 ? void 0 : _currentTheme$theme13.extra_small_font_size,
          fontWeight: "bold"
        },
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme14 = currentTheme.theme) === null || _currentTheme$theme14 === void 0 ? void 0 : _currentTheme$theme14.orange
      }, mapStateWithLabel(props === null || props === void 0 ? void 0 : (_props$currentMessage13 = props.currentMessage) === null || _props$currentMessage13 === void 0 ? void 0 : (_props$currentMessage14 = _props$currentMessage13.metadata) === null || _props$currentMessage14 === void 0 ? void 0 : _props$currentMessage14.agent_processing_status)));
    } else {
      var _props$currentMessage17, _props$currentMessage18, _currentTheme$theme15, _currentTheme$theme16, _currentTheme$theme17, _props$currentMessage19, _props$currentMessage20, _currentTheme$theme18, _currentTheme$theme19, _currentTheme$theme20;
      if (!showLoading && props.currentMessage.loading) {
        var _props$currentMessage15, _props$currentMessage16;
        const _agent_status = props === null || props === void 0 ? void 0 : (_props$currentMessage15 = props.currentMessage) === null || _props$currentMessage15 === void 0 ? void 0 : (_props$currentMessage16 = _props$currentMessage15.metadata) === null || _props$currentMessage16 === void 0 ? void 0 : _props$currentMessage16.agent_processing_status;
        if (["data_processing_completed", "tools_processing_completed", "replying"].includes(_agent_status) && !isWidget) textToDisplayWhileLoading = mapStateWithLabel(_agent_status);
        props.currentMessage.text = " ";
      }
      return /*#__PURE__*/React__default.createElement(Bubble, _extends({}, props, {
        isMessageLoading: props.currentMessage.loading,
        wrapperStyle: {
          left: [styles.bubbleStyle, {
            marginRight: isWebsite && 0,
            marginLeft: isWebsite && -10
          }, {
            borderRadius: showIconForGenericUser ? 10 : 5,
            backgroundColor: showIconForGenericUser && ((_props$currentMessage17 = props.currentMessage) === null || _props$currentMessage17 === void 0 ? void 0 : (_props$currentMessage18 = _props$currentMessage17.user) === null || _props$currentMessage18 === void 0 ? void 0 : _props$currentMessage18.name) === "user" ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme15 = currentTheme.theme) === null || _currentTheme$theme15 === void 0 ? void 0 : _currentTheme$theme15.lightGrey : props.currentMessage.user.id === user.id ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme16 = currentTheme.theme) === null || _currentTheme$theme16 === void 0 ? void 0 : _currentTheme$theme16.transparent : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme17 = currentTheme.theme) === null || _currentTheme$theme17 === void 0 ? void 0 : _currentTheme$theme17.message_bubble_background
          }],
          right: [styles.bubbleStyle, {
            marginLeft: isWebsite && 0,
            marginRight: isWebsite && 6
          }, {
            borderRadius: showIconForGenericUser ? 10 : 5,
            backgroundColor: showIconForGenericUser && ((_props$currentMessage19 = props.currentMessage) === null || _props$currentMessage19 === void 0 ? void 0 : (_props$currentMessage20 = _props$currentMessage19.user) === null || _props$currentMessage20 === void 0 ? void 0 : _props$currentMessage20.name) === "user" ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme18 = currentTheme.theme) === null || _currentTheme$theme18 === void 0 ? void 0 : _currentTheme$theme18.lightGrey : props.currentMessage.user.id === user.id ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme19 = currentTheme.theme) === null || _currentTheme$theme19 === void 0 ? void 0 : _currentTheme$theme19.transparent : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme20 = currentTheme.theme) === null || _currentTheme$theme20 === void 0 ? void 0 : _currentTheme$theme20.message_bubble_background
          }]
        }
        // position={props.currentMessage.user.id === user.id ? "right" : "left"}
        ,
        renderTime: renderTime,
        textStyle: {
          left: styles.textStyle,
          right: [styles.textStyle]
        },
        renderMessageText: messageProps => {
          var _messageProps$current, _messageProps$current2, _messageProps$current3, _messageProps$current4, _messageProps$current5, _messageProps$current6, _messageProps$current7, _messageProps$current8, _messageProps$current9, _messageProps$current10, _messageProps$current11, _messageProps$current12, _messageProps$current13, _messageProps$current14, _messageProps$current15, _messageProps$current16, _messageProps$current17, _messageProps$current18, _messageProps$current19, _messageProps$current20, _messageProps$current21, _messageProps$current22, _messageProps$current23, _messageProps$current24, _messageProps$current25, _messageProps$current26, _messageProps$current27, _messageProps$current28, _messageProps$current29, _messageProps$current30, _props$currentMessage21, _props$currentMessage22, _messageProps$current31, _messageProps$current32, _messageProps$current33, _messageProps$current34, _messageProps$current35, _props$currentMessage23, _props$currentMessage24, _messageProps$current36, _messageProps$current37, _messageProps$current38, _messageProps$current39, _messageProps$current40, _props$currentMessage25, _props$currentMessage26, _messageProps$current41, _messageProps$current42, _props$currentMessage27, _currentTheme$theme21, _currentTheme$theme22, _props$currentMessage28, _props$currentMessage29, _props$currentMessage30, _currentTheme$theme23, _messageProps$current43, _messageProps$current44, _messageProps$current45, _messageProps$current46, _AppAssets$icons5, _messageProps$current47, _messageProps$current48, _messageProps$current49, _messageProps$current50, _currentTheme$theme24, _currentTheme$theme25, _messageProps$current51, _messageProps$current52, _currentTheme$theme26, _currentTheme$theme27, _messageProps$current53, _messageProps$current54, _messageProps$current55, _messageProps$current56, _messageProps$current57, _messageProps$current58, _messageProps$current59, _messageProps$current60, _messageProps$current61, _messageProps$current62, _messageProps$current63, _messageProps$current64, _messageProps$current65, _messageProps$current66, _messageProps$current67, _messageProps$current68, _messageProps$current69, _messageProps$current70, _messageProps$current71, _messageProps$current72, _messageProps$current73, _messageProps$current74, _exec_metadata$output, _messageProps$current75, _messageProps$current76, _messageProps$current77, _messageProps$current78, _currentTheme$theme28, _AppAssets$icons7, _currentTheme$theme29, _messageProps$current91, _messageProps$current92, _currentTheme$theme30, _currentTheme$theme31, _messageProps$current94, _messageProps$current95, _messageProps$current96, _AppAssets$icons8, _messageProps$current97, _currentTheme$theme32, _currentTheme$theme33, _AppAssets$icons9, _messageProps$current99, _currentTheme$theme34, _currentTheme$theme35, _props$currentMessage32, _props$currentMessage33, _currentTheme$theme42, _currentTheme$theme43, _currentTheme$theme44, _AppAssets$icons12, _messageProps$current101, _messageProps$current102, _messageProps$current103, _messageProps$current104, _currentTheme$theme45, _currentTheme$theme46, _AppAssets$icons13, _messageProps$current105, _messageProps$current106, _messageProps$current107, _messageProps$current108, _messageProps$current109, _currentTheme$theme47, _currentTheme$theme48, _AppAssets$icons14, _messageProps$current110, _messageProps$current111, _messageProps$current112, _messageProps$current113, _messageProps$current114, _currentTheme$theme49, _currentTheme$theme50, _AppAssets$icons15, _messageProps$current115, _messageProps$current116, _messageProps$current117, _messageProps$current118, _messageProps$current119, _currentTheme$theme51, _currentTheme$theme52, _AppAssets$icons16, _messageProps$current120, _messageProps$current121, _messageProps$current122;
          const placeholder = "".concat(textToDisplayWhileLoading, " ").concat(cursor);
          const suggestions = [...((messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current = messageProps.currentMessage) === null || _messageProps$current === void 0 ? void 0 : (_messageProps$current2 = _messageProps$current.metadata) === null || _messageProps$current2 === void 0 ? void 0 : (_messageProps$current3 = _messageProps$current2.fnDetails) === null || _messageProps$current3 === void 0 ? void 0 : _messageProps$current3.filter(u => ((u === null || u === void 0 ? void 0 : u.type) == "suggestion" || (u === null || u === void 0 ? void 0 : u.type) == "nextQuestion") && (u === null || u === void 0 ? void 0 : u.response))) || []), ...((messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current4 = messageProps.currentMessage) === null || _messageProps$current4 === void 0 ? void 0 : (_messageProps$current5 = _messageProps$current4.callbackMetadata) === null || _messageProps$current5 === void 0 ? void 0 : (_messageProps$current6 = _messageProps$current5.fnDetails) === null || _messageProps$current6 === void 0 ? void 0 : _messageProps$current6.filter(u => ((u === null || u === void 0 ? void 0 : u.type) == "suggestion" || (u === null || u === void 0 ? void 0 : u.type) == "nextQuestion") && (u === null || u === void 0 ? void 0 : u.response))) || [])];
          const detailsCount = ((messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current7 = messageProps.currentMessage) === null || _messageProps$current7 === void 0 ? void 0 : (_messageProps$current8 = _messageProps$current7.metadata) === null || _messageProps$current8 === void 0 ? void 0 : (_messageProps$current9 = _messageProps$current8.fnDetails) === null || _messageProps$current9 === void 0 ? void 0 : _messageProps$current9.length) || 0) + ((messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current10 = messageProps.currentMessage) === null || _messageProps$current10 === void 0 ? void 0 : (_messageProps$current11 = _messageProps$current10.callbackMetadata) === null || _messageProps$current11 === void 0 ? void 0 : (_messageProps$current12 = _messageProps$current11.fnDetails) === null || _messageProps$current12 === void 0 ? void 0 : _messageProps$current12.length) || 0) + (messageProps !== null && messageProps !== void 0 && (_messageProps$current13 = messageProps.currentMessage) !== null && _messageProps$current13 !== void 0 && (_messageProps$current14 = _messageProps$current13.metadata) !== null && _messageProps$current14 !== void 0 && (_messageProps$current15 = _messageProps$current14.customerRetrieval) !== null && _messageProps$current15 !== void 0 && _messageProps$current15.length ? 1 : 0) + (messageProps !== null && messageProps !== void 0 && (_messageProps$current16 = messageProps.currentMessage) !== null && _messageProps$current16 !== void 0 && (_messageProps$current17 = _messageProps$current16.metadata) !== null && _messageProps$current17 !== void 0 && (_messageProps$current18 = _messageProps$current17.caseInfo) !== null && _messageProps$current18 !== void 0 && _messageProps$current18.length ? 1 : 0) + ((messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current19 = messageProps.currentMessage) === null || _messageProps$current19 === void 0 ? void 0 : (_messageProps$current20 = _messageProps$current19.metadata) === null || _messageProps$current20 === void 0 ? void 0 : (_messageProps$current21 = _messageProps$current20.sources) === null || _messageProps$current21 === void 0 ? void 0 : _messageProps$current21.length) > 0 ? 1 : 0);
          const exec_metadata = messageProps !== null && messageProps !== void 0 && (_messageProps$current22 = messageProps.currentMessage) !== null && _messageProps$current22 !== void 0 && (_messageProps$current23 = _messageProps$current22.metadata) !== null && _messageProps$current23 !== void 0 && _messageProps$current23.exec_result ? JSON.parse(messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current24 = messageProps.currentMessage) === null || _messageProps$current24 === void 0 ? void 0 : (_messageProps$current25 = _messageProps$current24.metadata) === null || _messageProps$current25 === void 0 ? void 0 : _messageProps$current25.exec_result) : null;
          return /*#__PURE__*/React__default.createElement(AppFadeView, {
            duration: 500
          }, messageProps !== null && messageProps !== void 0 && (_messageProps$current26 = messageProps.currentMessage) !== null && _messageProps$current26 !== void 0 && (_messageProps$current27 = _messageProps$current26.metadata) !== null && _messageProps$current27 !== void 0 && _messageProps$current27.generated_images && (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current28 = messageProps.currentMessage) === null || _messageProps$current28 === void 0 ? void 0 : (_messageProps$current29 = _messageProps$current28.metadata) === null || _messageProps$current29 === void 0 ? void 0 : (_messageProps$current30 = _messageProps$current29.generated_images) === null || _messageProps$current30 === void 0 ? void 0 : _messageProps$current30.length) > 0 ? /*#__PURE__*/React__default.createElement(ImageGeneration, {
            _urls: props === null || props === void 0 ? void 0 : (_props$currentMessage21 = props.currentMessage) === null || _props$currentMessage21 === void 0 ? void 0 : (_props$currentMessage22 = _props$currentMessage21.metadata) === null || _props$currentMessage22 === void 0 ? void 0 : _props$currentMessage22.generated_images,
            onImageSelected: onImageSelected,
            selectedImage: selectedImageKey,
            S3downloadUrlRequest: S3downloadUrlRequest,
            workspaceid: workspaceid
          }) : messageProps !== null && messageProps !== void 0 && (_messageProps$current31 = messageProps.currentMessage) !== null && _messageProps$current31 !== void 0 && (_messageProps$current32 = _messageProps$current31.metadata) !== null && _messageProps$current32 !== void 0 && _messageProps$current32.generated_videos && (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current33 = messageProps.currentMessage) === null || _messageProps$current33 === void 0 ? void 0 : (_messageProps$current34 = _messageProps$current33.metadata) === null || _messageProps$current34 === void 0 ? void 0 : (_messageProps$current35 = _messageProps$current34.generated_videos) === null || _messageProps$current35 === void 0 ? void 0 : _messageProps$current35.length) > 0 ? /*#__PURE__*/React__default.createElement(VideoGeneration, {
            _urls: props === null || props === void 0 ? void 0 : (_props$currentMessage23 = props.currentMessage) === null || _props$currentMessage23 === void 0 ? void 0 : (_props$currentMessage24 = _props$currentMessage23.metadata) === null || _props$currentMessage24 === void 0 ? void 0 : _props$currentMessage24.generated_videos,
            onVideoSelected: onVideoSelected,
            S3downloadUrlRequest: S3downloadUrlRequest,
            workspaceid: workspaceid
          }) : messageProps !== null && messageProps !== void 0 && (_messageProps$current36 = messageProps.currentMessage) !== null && _messageProps$current36 !== void 0 && (_messageProps$current37 = _messageProps$current36.metadata) !== null && _messageProps$current37 !== void 0 && _messageProps$current37.generated_models && (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current38 = messageProps.currentMessage) === null || _messageProps$current38 === void 0 ? void 0 : (_messageProps$current39 = _messageProps$current38.metadata) === null || _messageProps$current39 === void 0 ? void 0 : (_messageProps$current40 = _messageProps$current39.generated_models) === null || _messageProps$current40 === void 0 ? void 0 : _messageProps$current40.length) > 0 ? /*#__PURE__*/React__default.createElement(ThreeDModelViewer, {
            _urls: props === null || props === void 0 ? void 0 : (_props$currentMessage25 = props.currentMessage) === null || _props$currentMessage25 === void 0 ? void 0 : (_props$currentMessage26 = _props$currentMessage25.metadata) === null || _props$currentMessage26 === void 0 ? void 0 : _props$currentMessage26.generated_models,
            videoUrl: null,
            imageUrl: null,
            onModelSelected: e => {
              console.log("onModelSelected", e);
            },
            S3downloadUrlRequest: S3downloadUrlRequest,
            workspaceid: workspaceid
          }) : ((messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current41 = messageProps.currentMessage) === null || _messageProps$current41 === void 0 ? void 0 : (_messageProps$current42 = _messageProps$current41.user) === null || _messageProps$current42 === void 0 ? void 0 : _messageProps$current42.name) == "assistant" || (props === null || props === void 0 ? void 0 : (_props$currentMessage27 = props.currentMessage) === null || _props$currentMessage27 === void 0 ? void 0 : _props$currentMessage27.agentName)) && showAgentName && /*#__PURE__*/React__default.createElement(AppText, {
            color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme21 = currentTheme.theme) === null || _currentTheme$theme21 === void 0 ? void 0 : _currentTheme$theme21.mediumGrey,
            style: {
              fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme22 = currentTheme.theme) === null || _currentTheme$theme22 === void 0 ? void 0 : _currentTheme$theme22.extra_small_font_size,
              marginTop: 2,
              fontFamily: "boldFont"
            }
          }, (props === null || props === void 0 ? void 0 : (_props$currentMessage28 = props.currentMessage) === null || _props$currentMessage28 === void 0 ? void 0 : _props$currentMessage28.agentName) || (props === null || props === void 0 ? void 0 : (_props$currentMessage29 = props.currentMessage) === null || _props$currentMessage29 === void 0 ? void 0 : (_props$currentMessage30 = _props$currentMessage29.user) === null || _props$currentMessage30 === void 0 ? void 0 : _props$currentMessage30.agentName)), /*#__PURE__*/React__default.createElement(AppText, {
            copyIconColor: agentColor || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme23 = currentTheme.theme) === null || _currentTheme$theme23 === void 0 ? void 0 : _currentTheme$theme23.primary),
            S3downloadUrlRequest: S3downloadUrlRequest,
            workspaceid: workspaceid,
            renderMarkdown: renderMarkdown,
            renderHTMLLinkPreview: renderHTMLLinkPreview,
            isSpeechGettingProcessed: isSpeechGettingProcessed,
            updateTextForSpeech: (t, b) => {
              var _props$currentMessage31;
              return updateTextForSpeech(t, chatid, props === null || props === void 0 ? void 0 : (_props$currentMessage31 = props.currentMessage) === null || _props$currentMessage31 === void 0 ? void 0 : _props$currentMessage31._id, b);
            },
            showTextToSpeech: showTextToSpeech,
            showCopyButton: !isWebsite,
            onCopy: onCopy,
            customChartingConfig: customChartingConfig,
            coder: coder,
            showCodeInExecution: showCodeInExecution,
            hideReasoning: hideReasoning && (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current43 = messageProps.currentMessage) === null || _messageProps$current43 === void 0 ? void 0 : (_messageProps$current44 = _messageProps$current43.user) === null || _messageProps$current44 === void 0 ? void 0 : _messageProps$current44.name) === "assistant",
            renderHTMLinMarkdown: (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current45 = messageProps.currentMessage) === null || _messageProps$current45 === void 0 ? void 0 : (_messageProps$current46 = _messageProps$current45.user) === null || _messageProps$current46 === void 0 ? void 0 : _messageProps$current46.name) === "assistant" || plannerMode,
            wrapperStyle: {
              alignItems: "flex-start"
            },
            leftIcon: showIconOnInputLeft && (AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons5 = AppAssets.icons) === null || _AppAssets$icons5 === void 0 ? void 0 : _AppAssets$icons5.arrow_right),
            leftIconColor: !isWebsite && (user === null || user === void 0 ? void 0 : user.id) === (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current47 = messageProps.currentMessage) === null || _messageProps$current47 === void 0 ? void 0 : (_messageProps$current48 = _messageProps$current47.user) === null || _messageProps$current48 === void 0 ? void 0 : _messageProps$current48.id) || isWebsite && (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current49 = messageProps.currentMessage) === null || _messageProps$current49 === void 0 ? void 0 : (_messageProps$current50 = _messageProps$current49.user) === null || _messageProps$current50 === void 0 ? void 0 : _messageProps$current50.role) === "user" ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme24 = currentTheme.theme) === null || _currentTheme$theme24 === void 0 ? void 0 : _currentTheme$theme24.primary : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme25 = currentTheme.theme) === null || _currentTheme$theme25 === void 0 ? void 0 : _currentTheme$theme25.mediumGrey,
            iconSize: 16,
            leftIconStyle: {
              marginTop: isWebsite && 4
            },
            style: {
              color: isWebsite && (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current51 = messageProps.currentMessage) === null || _messageProps$current51 === void 0 ? void 0 : (_messageProps$current52 = _messageProps$current51.user) === null || _messageProps$current52 === void 0 ? void 0 : _messageProps$current52.role) === "user" ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme26 = currentTheme.theme) === null || _currentTheme$theme26 === void 0 ? void 0 : _currentTheme$theme26.primary : currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.theme[textColor],
              fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme27 = currentTheme.theme) === null || _currentTheme$theme27 === void 0 ? void 0 : _currentTheme$theme27.small_font_size,
              fontWeight: "400",
              lineHeight: 18,
              marginLeft: 10
            }
          }, messageProps !== null && messageProps !== void 0 && (_messageProps$current53 = messageProps.currentMessage) !== null && _messageProps$current53 !== void 0 && _messageProps$current53.loading ? placeholder : messageProps.currentMessage.text), (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current54 = messageProps.currentMessage) === null || _messageProps$current54 === void 0 ? void 0 : (_messageProps$current55 = _messageProps$current54.images) === null || _messageProps$current55 === void 0 ? void 0 : _messageProps$current55.length) > 0 && /*#__PURE__*/React__default.createElement(View, {
            style: {
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "flex-start",
              gap: 5,
              overflowX: "auto"
            }
          }, messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current56 = messageProps.currentMessage) === null || _messageProps$current56 === void 0 ? void 0 : (_messageProps$current57 = _messageProps$current56.images) === null || _messageProps$current57 === void 0 ? void 0 : _messageProps$current57.map(u => {
            return /*#__PURE__*/React__default.createElement(ImagePreview, {
              key: u,
              path: u,
              workspaceid: workspaceid,
              S3downloadUrlRequest: S3downloadUrlRequest
            });
          })), (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current58 = messageProps.currentMessage) === null || _messageProps$current58 === void 0 ? void 0 : (_messageProps$current59 = _messageProps$current58.videos) === null || _messageProps$current59 === void 0 ? void 0 : _messageProps$current59.length) > 0 && /*#__PURE__*/React__default.createElement(View, {
            style: {
              flexDirection: "column",
              flexWrap: "wrap",
              alignItems: "flex-start",
              gap: 5
            }
          }, messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current60 = messageProps.currentMessage) === null || _messageProps$current60 === void 0 ? void 0 : (_messageProps$current61 = _messageProps$current60.videos) === null || _messageProps$current61 === void 0 ? void 0 : _messageProps$current61.map(u => {
            return /*#__PURE__*/React__default.createElement(ImagePreview, {
              key: u,
              path: u,
              workspaceid: workspaceid,
              S3downloadUrlRequest: S3downloadUrlRequest,
              type: "video"
            });
          })), (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current62 = messageProps.currentMessage) === null || _messageProps$current62 === void 0 ? void 0 : (_messageProps$current63 = _messageProps$current62.audios) === null || _messageProps$current63 === void 0 ? void 0 : _messageProps$current63.length) > 0 && /*#__PURE__*/React__default.createElement(View, {
            style: {
              flexDirection: "column",
              flexWrap: "wrap",
              alignItems: "flex-start",
              gap: 5
            }
          }, messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current64 = messageProps.currentMessage) === null || _messageProps$current64 === void 0 ? void 0 : (_messageProps$current65 = _messageProps$current64.audios) === null || _messageProps$current65 === void 0 ? void 0 : _messageProps$current65.map(u => {
            return /*#__PURE__*/React__default.createElement(ImagePreview, {
              key: u,
              path: u,
              workspaceid: workspaceid,
              S3downloadUrlRequest: S3downloadUrlRequest,
              type: "audio"
            });
          })), (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current66 = messageProps.currentMessage) === null || _messageProps$current66 === void 0 ? void 0 : (_messageProps$current67 = _messageProps$current66.files) === null || _messageProps$current67 === void 0 ? void 0 : _messageProps$current67.length) > 0 && /*#__PURE__*/React__default.createElement(View, {
            style: {
              flexDirection: "column",
              flexWrap: "wrap",
              alignItems: "flex-start",
              gap: 5
            }
          }, messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current68 = messageProps.currentMessage) === null || _messageProps$current68 === void 0 ? void 0 : (_messageProps$current69 = _messageProps$current68.files) === null || _messageProps$current69 === void 0 ? void 0 : _messageProps$current69.map(u => {
            var _u$split$pop;
            const ext = (u === null || u === void 0 ? void 0 : (_u$split$pop = u.split(".").pop()) === null || _u$split$pop === void 0 ? void 0 : _u$split$pop.toLowerCase()) || "";
            return /*#__PURE__*/React__default.createElement(ImagePreview, {
              key: u,
              path: u,
              workspaceid: workspaceid,
              S3downloadUrlRequest: S3downloadUrlRequest,
              type: attemptConversionOfExtensionToType(ext)
            });
          })), (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current70 = messageProps.currentMessage) === null || _messageProps$current70 === void 0 ? void 0 : (_messageProps$current71 = _messageProps$current70.metadata) === null || _messageProps$current71 === void 0 ? void 0 : _messageProps$current71.generated_audio) && /*#__PURE__*/React__default.createElement(View, {
            style: {
              flexDirection: "column",
              flexWrap: "wrap",
              alignItems: "flex-start",
              gap: 5,
              marginVertical: 5
            }
          }, messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current72 = messageProps.currentMessage) === null || _messageProps$current72 === void 0 ? void 0 : (_messageProps$current73 = _messageProps$current72.metadata) === null || _messageProps$current73 === void 0 ? void 0 : (_messageProps$current74 = _messageProps$current73.generated_audio) === null || _messageProps$current74 === void 0 ? void 0 : _messageProps$current74.map(u => {
            var _AppAssets$icons6;
            return /*#__PURE__*/React__default.createElement(View, {
              style: {
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 5
              },
              key: u
            }, /*#__PURE__*/React__default.createElement(ImagePreview, {
              leftIcon: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons6 = AppAssets.icons) === null || _AppAssets$icons6 === void 0 ? void 0 : _AppAssets$icons6.speakers,
              onPress: u => listenToAudio(u),
              path: u,
              workspaceid: workspaceid,
              S3downloadUrlRequest: S3downloadUrlRequest,
              type: "audio",
              staticText: "Listen"
            }), /*#__PURE__*/React__default.createElement(ImagePreview, {
              path: u,
              workspaceid: workspaceid,
              S3downloadUrlRequest: S3downloadUrlRequest,
              type: "audio",
              staticText: "Download"
            }));
          })), exec_metadata && /*#__PURE__*/React__default.createElement(View, {
            style: {
              flexDirection: "column",
              flexWrap: "wrap",
              alignItems: "flex-start",
              gap: 5,
              marginBottom: 10
            }
          }, exec_metadata === null || exec_metadata === void 0 ? void 0 : (_exec_metadata$output = exec_metadata.output_files) === null || _exec_metadata$output === void 0 ? void 0 : _exec_metadata$output.sort((a, b) => {
            var _a$split$pop, _b$split$pop;
            const extA = (a === null || a === void 0 ? void 0 : (_a$split$pop = a.split(".").pop()) === null || _a$split$pop === void 0 ? void 0 : _a$split$pop.toLowerCase()) || "";
            const extB = (b === null || b === void 0 ? void 0 : (_b$split$pop = b.split(".").pop()) === null || _b$split$pop === void 0 ? void 0 : _b$split$pop.toLowerCase()) || "";
            if (extA < extB) {
              return -1;
            }
            if (extA > extB) {
              return 1;
            }
            return 0;
          }).map(u => {
            var _u$split$pop2;
            const ext = (u === null || u === void 0 ? void 0 : (_u$split$pop2 = u.split(".").pop()) === null || _u$split$pop2 === void 0 ? void 0 : _u$split$pop2.toLowerCase()) || "";
            return /*#__PURE__*/React__default.createElement(ImagePreview, {
              key: u,
              path: u,
              workspaceid: workspaceid,
              S3downloadUrlRequest: S3downloadUrlRequest,
              type: attemptConversionOfExtensionToType(ext),
              imgStyle: {
                width: "90%",
                height: "auto",
                marginTop: 10,
                marginBottom: 10
              }
            });
          })), (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current75 = messageProps.currentMessage) === null || _messageProps$current75 === void 0 ? void 0 : (_messageProps$current76 = _messageProps$current75.metadata) === null || _messageProps$current76 === void 0 ? void 0 : _messageProps$current76.internetSearch) && /*#__PURE__*/React__default.createElement(InternetSearch, {
            internetSearch: messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current77 = messageProps.currentMessage) === null || _messageProps$current77 === void 0 ? void 0 : (_messageProps$current78 = _messageProps$current77.metadata) === null || _messageProps$current78 === void 0 ? void 0 : _messageProps$current78.internetSearch
          }), /*#__PURE__*/React__default.createElement(View, {
            style: {
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "space-between",
              marginTop: 5
            }
          }, /*#__PURE__*/React__default.createElement(View, {
            style: {
              flexDirection: "row",
              alignItems: "center",
              paddingVertical: 5
            }
          }, detailsCount > 0 && !isWidget && /*#__PURE__*/React__default.createElement(AppText, {
            wrapperStyle: {
              marginTop: 2,
              marginRight: 10
            },
            color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme28 = currentTheme.theme) === null || _currentTheme$theme28 === void 0 ? void 0 : _currentTheme$theme28.primary,
            leftIcon: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons7 = AppAssets.icons) === null || _AppAssets$icons7 === void 0 ? void 0 : _AppAssets$icons7.tools,
            style: {
              fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme29 = currentTheme.theme) === null || _currentTheme$theme29 === void 0 ? void 0 : _currentTheme$theme29.extra_small_font_size,
              marginLeft: 3,
              marginTop: -8
            },
            iconSize: 14,
            isClickable: true,
            onPress: () => {
              var _messageProps$current79, _messageProps$current80, _messageProps$current81, _messageProps$current82, _messageProps$current83, _messageProps$current84, _messageProps$current85, _messageProps$current86, _messageProps$current87, _messageProps$current88, _messageProps$current89, _messageProps$current90;
              return handleShowSourcesDetails({
                docs: messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current79 = messageProps.currentMessage) === null || _messageProps$current79 === void 0 ? void 0 : (_messageProps$current80 = _messageProps$current79.metadata) === null || _messageProps$current80 === void 0 ? void 0 : _messageProps$current80.sources,
                webPages: messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current81 = messageProps.currentMessage) === null || _messageProps$current81 === void 0 ? void 0 : (_messageProps$current82 = _messageProps$current81.metadata) === null || _messageProps$current82 === void 0 ? void 0 : _messageProps$current82.webPages,
                fn: [...((messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current83 = messageProps.currentMessage) === null || _messageProps$current83 === void 0 ? void 0 : (_messageProps$current84 = _messageProps$current83.metadata) === null || _messageProps$current84 === void 0 ? void 0 : _messageProps$current84.fnDetails) || []), ...((messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current85 = messageProps.currentMessage) === null || _messageProps$current85 === void 0 ? void 0 : (_messageProps$current86 = _messageProps$current85.metadata) === null || _messageProps$current86 === void 0 ? void 0 : _messageProps$current86.customerRetrieval) || []), ...((messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current87 = messageProps.currentMessage) === null || _messageProps$current87 === void 0 ? void 0 : (_messageProps$current88 = _messageProps$current87.metadata) === null || _messageProps$current88 === void 0 ? void 0 : _messageProps$current88.caseInfo) || []), ...((messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current89 = messageProps.currentMessage) === null || _messageProps$current89 === void 0 ? void 0 : (_messageProps$current90 = _messageProps$current89.callbackMetadata) === null || _messageProps$current90 === void 0 ? void 0 : _messageProps$current90.fnDetails) || [])]
              });
            }
          }, "(".concat(detailsCount, ")")), messageProps !== null && messageProps !== void 0 && (_messageProps$current91 = messageProps.currentMessage) !== null && _messageProps$current91 !== void 0 && (_messageProps$current92 = _messageProps$current91.metadata) !== null && _messageProps$current92 !== void 0 && _messageProps$current92.quickApprove ? /*#__PURE__*/React__default.createElement(AppButton, {
            backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme30 = currentTheme.theme) === null || _currentTheme$theme30 === void 0 ? void 0 : _currentTheme$theme30.primary,
            style: [{
              height: 35,
              width: "auto",
              shadowColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme31 = currentTheme.theme) === null || _currentTheme$theme31 === void 0 ? void 0 : _currentTheme$theme31.transparent,
              marginHorizontal: 10
            }]
            // btnLabelStyle={{ fontSize: 16 }}
            ,
            wrapperStyle: [{
              width: "fit-content",
              minWidth: 150,
              marginLeft: -10
            }],
            title: "Approve",
            isClickable: true,
            onPress: () => {
              var _messageProps$current93;
              return handleQuickApprovePlanner(messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current93 = messageProps.currentMessage) === null || _messageProps$current93 === void 0 ? void 0 : _messageProps$current93._id);
            }
          }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null), allowFeedback && (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current94 = messageProps.currentMessage) === null || _messageProps$current94 === void 0 ? void 0 : (_messageProps$current95 = _messageProps$current94.user) === null || _messageProps$current95 === void 0 ? void 0 : _messageProps$current95.name) == "assistant" && (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current96 = messageProps.currentMessage) === null || _messageProps$current96 === void 0 ? void 0 : _messageProps$current96._id) != 2 && /*#__PURE__*/React__default.createElement(View, {
            style: {
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              width: 50
            }
          }, /*#__PURE__*/React__default.createElement(AppIcon, {
            icon: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons8 = AppAssets.icons) === null || _AppAssets$icons8 === void 0 ? void 0 : _AppAssets$icons8.thumbsUp,
            color: (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current97 = messageProps.currentMessage) === null || _messageProps$current97 === void 0 ? void 0 : _messageProps$current97.humanFeedback) == "positive" ? agentColor || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme32 = currentTheme.theme) === null || _currentTheme$theme32 === void 0 ? void 0 : _currentTheme$theme32.primary) : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme33 = currentTheme.theme) === null || _currentTheme$theme33 === void 0 ? void 0 : _currentTheme$theme33.mediumGrey,
            size: 16,
            isClickable: true,
            onPress: () => {
              var _messageProps$current98;
              handleFeedback(messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current98 = messageProps.currentMessage) === null || _messageProps$current98 === void 0 ? void 0 : _messageProps$current98._id, "positive");
            }
          }), /*#__PURE__*/React__default.createElement(AppIcon, {
            icon: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons9 = AppAssets.icons) === null || _AppAssets$icons9 === void 0 ? void 0 : _AppAssets$icons9.thumbsDown,
            size: 16,
            color: (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current99 = messageProps.currentMessage) === null || _messageProps$current99 === void 0 ? void 0 : _messageProps$current99.humanFeedback) == "negative" ? agentColor || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme34 = currentTheme.theme) === null || _currentTheme$theme34 === void 0 ? void 0 : _currentTheme$theme34.primary) : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme35 = currentTheme.theme) === null || _currentTheme$theme35 === void 0 ? void 0 : _currentTheme$theme35.mediumGrey,
            isClickable: true,
            onPress: () => {
              var _messageProps$current100;
              handleFeedback(messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current100 = messageProps.currentMessage) === null || _messageProps$current100 === void 0 ? void 0 : _messageProps$current100._id, "negative");
            }
          }))), /*#__PURE__*/React__default.createElement("div", {
            className: "suggestions-wrapper",
            style: {
              flexDirection: "column",
              maxWidth: "50%",
              display: "flex"
            }
          }, (suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) > 0 && (suggestions === null || suggestions === void 0 ? void 0 : suggestions.map((s, i) => {
            var _AppAssets$icons10, _AppAssets$icons11, _currentTheme$theme36, _currentTheme$theme37, _currentTheme$theme38, _currentTheme$theme39, _currentTheme$theme40, _currentTheme$theme41;
            return /*#__PURE__*/React__default.createElement(AppText, {
              showCopyButton: false,
              renderMarkdown: containsMarkdownLink(s === null || s === void 0 ? void 0 : s.response),
              leftIcon: !containsMarkdownLink(s === null || s === void 0 ? void 0 : s.response) ? (s === null || s === void 0 ? void 0 : s.type) == "suggestion" ? AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons10 = AppAssets.icons) === null || _AppAssets$icons10 === void 0 ? void 0 : _AppAssets$icons10.question_icon : AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons11 = AppAssets.icons) === null || _AppAssets$icons11 === void 0 ? void 0 : _AppAssets$icons11.arrow_right : null,
              iconSize: 12,
              leftIconColor: agentColor || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme36 = currentTheme.theme) === null || _currentTheme$theme36 === void 0 ? void 0 : _currentTheme$theme36.primary),
              wrapperStyle: {
                marginTop: 2,
                marginRight: 0,
                alignSelf: "flex-end",
                justifyContent: "flex-end",
                borderRadius: 3,
                borderWidth: 1,
                borderColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme37 = currentTheme.theme) === null || _currentTheme$theme37 === void 0 ? void 0 : _currentTheme$theme37.transparent,
                backgroundColor: hexToRGB(agentColor, 0.1) || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme38 = currentTheme.theme) === null || _currentTheme$theme38 === void 0 ? void 0 : _currentTheme$theme38.primary_soft),
                cursor: "pointer",
                padding: 5
              },
              color: agentColor || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme39 = currentTheme.theme) === null || _currentTheme$theme39 === void 0 ? void 0 : _currentTheme$theme39.primary),
              style: {
                fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme40 = currentTheme.theme) === null || _currentTheme$theme40 === void 0 ? void 0 : _currentTheme$theme40.extra_small_font_size,
                textDecorationColor: agentColor || (currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme41 = currentTheme.theme) === null || _currentTheme$theme41 === void 0 ? void 0 : _currentTheme$theme41.primary),
                marginLeft: 5
              },
              key: i,
              isClickable: !containsMarkdownLink(s === null || s === void 0 ? void 0 : s.response),
              onPress: () => {
                onSendEvent(s === null || s === void 0 ? void 0 : s.response);
              }
            }, "".concat(s === null || s === void 0 ? void 0 : s.response));
          })), showProcessingMetadata && ["memory_updated"].includes(props === null || props === void 0 ? void 0 : (_props$currentMessage32 = props.currentMessage) === null || _props$currentMessage32 === void 0 ? void 0 : (_props$currentMessage33 = _props$currentMessage32.metadata) === null || _props$currentMessage33 === void 0 ? void 0 : _props$currentMessage33.agent_processing_status) && /*#__PURE__*/React__default.createElement(AppText, {
            wrapperStyle: {
              marginTop: 2,
              marginRight: 0,
              alignSelf: "flex-end",
              minHeight: 20
            },
            style: {
              fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme42 = currentTheme.theme) === null || _currentTheme$theme42 === void 0 ? void 0 : _currentTheme$theme42.extra_small_font_size,
              fontWeight: "bold",
              marginLeft: 5
            },
            color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme43 = currentTheme.theme) === null || _currentTheme$theme43 === void 0 ? void 0 : _currentTheme$theme43.orange,
            leftIconColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme44 = currentTheme.theme) === null || _currentTheme$theme44 === void 0 ? void 0 : _currentTheme$theme44.orange,
            iconSize: 12,
            leftIcon: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons12 = AppAssets.icons) === null || _AppAssets$icons12 === void 0 ? void 0 : _AppAssets$icons12.memory
          }, mapStateWithLabel(messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current101 = messageProps.currentMessage) === null || _messageProps$current101 === void 0 ? void 0 : (_messageProps$current102 = _messageProps$current101.metadata) === null || _messageProps$current102 === void 0 ? void 0 : _messageProps$current102.agent_processing_status)), showDuration && (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current103 = messageProps.currentMessage) === null || _messageProps$current103 === void 0 ? void 0 : (_messageProps$current104 = _messageProps$current103.metadata) === null || _messageProps$current104 === void 0 ? void 0 : _messageProps$current104.duration) && /*#__PURE__*/React__default.createElement(AppText, {
            wrapperStyle: {
              marginTop: 2,
              marginRight: 0,
              alignSelf: "flex-end",
              justifyContent: "flex-end"
            },
            style: {
              marginLeft: 3,
              fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme45 = currentTheme.theme) === null || _currentTheme$theme45 === void 0 ? void 0 : _currentTheme$theme45.extra_small_font_size
            },
            leftIconColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme46 = currentTheme.theme) === null || _currentTheme$theme46 === void 0 ? void 0 : _currentTheme$theme46.font_color,
            iconSize: 11,
            leftIcon: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons13 = AppAssets.icons) === null || _AppAssets$icons13 === void 0 ? void 0 : _AppAssets$icons13.duration
          }, "".concat(parseFloat(messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current105 = messageProps.currentMessage) === null || _messageProps$current105 === void 0 ? void 0 : (_messageProps$current106 = _messageProps$current105.metadata) === null || _messageProps$current106 === void 0 ? void 0 : (_messageProps$current107 = _messageProps$current106.duration) === null || _messageProps$current107 === void 0 ? void 0 : _messageProps$current107.toFixed(2)), " sec")), (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current108 = messageProps.currentMessage) === null || _messageProps$current108 === void 0 ? void 0 : (_messageProps$current109 = _messageProps$current108.metadata) === null || _messageProps$current109 === void 0 ? void 0 : _messageProps$current109.thinkingTime) > 0 ? /*#__PURE__*/React__default.createElement(AppText, {
            wrapperStyle: {
              marginTop: 2,
              marginRight: 0,
              alignSelf: "flex-end",
              justifyContent: "flex-end"
            },
            style: {
              fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme47 = currentTheme.theme) === null || _currentTheme$theme47 === void 0 ? void 0 : _currentTheme$theme47.extra_small_font_size,
              marginLeft: 3
            },
            leftIconColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme48 = currentTheme.theme) === null || _currentTheme$theme48 === void 0 ? void 0 : _currentTheme$theme48.font_color,
            iconSize: 12,
            leftIcon: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons14 = AppAssets.icons) === null || _AppAssets$icons14 === void 0 ? void 0 : _AppAssets$icons14.reasoning
          }, "".concat(parseFloat(messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current110 = messageProps.currentMessage) === null || _messageProps$current110 === void 0 ? void 0 : (_messageProps$current111 = _messageProps$current110.metadata) === null || _messageProps$current111 === void 0 ? void 0 : (_messageProps$current112 = _messageProps$current111.thinkingTime) === null || _messageProps$current112 === void 0 ? void 0 : _messageProps$current112.toFixed(2)), " sec")) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null), showLanguage && (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current113 = messageProps.currentMessage) === null || _messageProps$current113 === void 0 ? void 0 : (_messageProps$current114 = _messageProps$current113.metadata) === null || _messageProps$current114 === void 0 ? void 0 : _messageProps$current114.targetLanguage) && /*#__PURE__*/React__default.createElement(AppText, {
            wrapperStyle: {
              marginTop: 2,
              marginRight: 0,
              alignSelf: "flex-end",
              justifyContent: "flex-end"
            },
            style: {
              fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme49 = currentTheme.theme) === null || _currentTheme$theme49 === void 0 ? void 0 : _currentTheme$theme49.extra_small_font_size,
              marginLeft: 3
            },
            leftIconColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme50 = currentTheme.theme) === null || _currentTheme$theme50 === void 0 ? void 0 : _currentTheme$theme50.font_color,
            iconSize: 12,
            leftIcon: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons15 = AppAssets.icons) === null || _AppAssets$icons15 === void 0 ? void 0 : _AppAssets$icons15.language
          }, "".concat(messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current115 = messageProps.currentMessage) === null || _messageProps$current115 === void 0 ? void 0 : (_messageProps$current116 = _messageProps$current115.metadata) === null || _messageProps$current116 === void 0 ? void 0 : (_messageProps$current117 = _messageProps$current116.targetLanguage) === null || _messageProps$current117 === void 0 ? void 0 : _messageProps$current117.toUpperCase())), showRoutedModel && (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current118 = messageProps.currentMessage) === null || _messageProps$current118 === void 0 ? void 0 : (_messageProps$current119 = _messageProps$current118.metadata) === null || _messageProps$current119 === void 0 ? void 0 : _messageProps$current119.routedModel) && /*#__PURE__*/React__default.createElement(AppText, {
            wrapperStyle: {
              marginTop: 2,
              marginRight: 0,
              alignSelf: "flex-end",
              justifyContent: "flex-end"
            },
            style: {
              fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme51 = currentTheme.theme) === null || _currentTheme$theme51 === void 0 ? void 0 : _currentTheme$theme51.extra_small_font_size,
              marginLeft: 3
            },
            leftIconColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme52 = currentTheme.theme) === null || _currentTheme$theme52 === void 0 ? void 0 : _currentTheme$theme52.font_color,
            iconSize: 12,
            leftIcon: AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons16 = AppAssets.icons) === null || _AppAssets$icons16 === void 0 ? void 0 : _AppAssets$icons16.route
          }, "".concat(messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current120 = messageProps.currentMessage) === null || _messageProps$current120 === void 0 ? void 0 : (_messageProps$current121 = _messageProps$current120.metadata) === null || _messageProps$current121 === void 0 ? void 0 : _messageProps$current121.routedModel)))), (messageProps === null || messageProps === void 0 ? void 0 : (_messageProps$current122 = messageProps.currentMessage) === null || _messageProps$current122 === void 0 ? void 0 : _messageProps$current122.humanFeedback) == "negative" && rlhf ? /*#__PURE__*/React__default.createElement(MessageFeedback, {
            handleFeedback: handleFeedback,
            message: messageProps === null || messageProps === void 0 ? void 0 : messageProps.currentMessage
          }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null));
        }
      }));
    }
  };
  const onSend = () => {
    const messages = [{
      _id: Math.round(Math.random() * 1000000),
      text: inputText,
      createdAt: new Date(),
      user: {
        _id: user.id,
        name: user.name
      }
    }];
    setMessages(previousMessages => GiftedChat.append(previousMessages, messages));
    onSendEvent(messages);
  };
  // create a function that sorts an array of messages by date from the oldest to the newest
  function sortObjectsByDate(objArray) {
    let sortOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "asc";
    return objArray.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      const direction = sortOrder === "asc" ? 1 : -1;
      return direction * (dateA - dateB);
    });
  }
  return /*#__PURE__*/React__default.createElement(View, {
    style: {
      ...chatStyle
    }
  }, /*#__PURE__*/React__default.createElement(GiftedChat, _extends({
    renderDay: props => {
      if (isDayDisplayed) {
        return /*#__PURE__*/React__default.createElement(Day, props);
      } else {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
      }
    },
    ref: chatBoxRef,
    key: "".concat(chatid || "", "-").concat(mode),
    scrollToBottom: scrollToBottom && !isLoadingEarlier,
    loadEarlier: loadEarlier,
    shouldUpdateMessage: (props, nextProps) => {
      var _nextProps$currentMes, _nextProps$currentMes2, _nextProps$currentMes3, _nextProps$currentMes4, _nextProps$currentMes5, _nextProps$currentMes6, _nextProps$currentMes7, _nextProps$currentMes8, _nextProps$currentMes9, _props$currentMessage34, _props$currentMessage35, _nextProps$currentMes10, _props$currentMessage36, _props$currentMessage37, _nextProps$currentMes11, _nextProps$currentMes12;
      return (nextProps === null || nextProps === void 0 ? void 0 : (_nextProps$currentMes = nextProps.currentMessage) === null || _nextProps$currentMes === void 0 ? void 0 : _nextProps$currentMes.images) || (nextProps === null || nextProps === void 0 ? void 0 : (_nextProps$currentMes2 = nextProps.currentMessage) === null || _nextProps$currentMes2 === void 0 ? void 0 : _nextProps$currentMes2.audios) || (nextProps === null || nextProps === void 0 ? void 0 : (_nextProps$currentMes3 = nextProps.currentMessage) === null || _nextProps$currentMes3 === void 0 ? void 0 : _nextProps$currentMes3.videos) || (nextProps === null || nextProps === void 0 ? void 0 : (_nextProps$currentMes4 = nextProps.currentMessage) === null || _nextProps$currentMes4 === void 0 ? void 0 : _nextProps$currentMes4.files) || (nextProps === null || nextProps === void 0 ? void 0 : (_nextProps$currentMes5 = nextProps.currentMessage) === null || _nextProps$currentMes5 === void 0 ? void 0 : (_nextProps$currentMes6 = _nextProps$currentMes5.metadata) === null || _nextProps$currentMes6 === void 0 ? void 0 : _nextProps$currentMes6.agent_processing_status) || (nextProps === null || nextProps === void 0 ? void 0 : (_nextProps$currentMes7 = nextProps.currentMessage) === null || _nextProps$currentMes7 === void 0 ? void 0 : (_nextProps$currentMes8 = _nextProps$currentMes7.metadata) === null || _nextProps$currentMes8 === void 0 ? void 0 : _nextProps$currentMes8.generated_audio) || (nextProps === null || nextProps === void 0 ? void 0 : (_nextProps$currentMes9 = nextProps.currentMessage) === null || _nextProps$currentMes9 === void 0 ? void 0 : _nextProps$currentMes9.humanFeedback) == "negative" || (props === null || props === void 0 ? void 0 : (_props$currentMessage34 = props.currentMessage) === null || _props$currentMessage34 === void 0 ? void 0 : _props$currentMessage34.humanFeedback) == "negative" || (props === null || props === void 0 ? void 0 : (_props$currentMessage35 = props.currentMessage) === null || _props$currentMessage35 === void 0 ? void 0 : _props$currentMessage35.humanFeedback) != (nextProps === null || nextProps === void 0 ? void 0 : (_nextProps$currentMes10 = nextProps.currentMessage) === null || _nextProps$currentMes10 === void 0 ? void 0 : _nextProps$currentMes10.humanFeedback) || (props === null || props === void 0 ? void 0 : (_props$currentMessage36 = props.currentMessage) === null || _props$currentMessage36 === void 0 ? void 0 : (_props$currentMessage37 = _props$currentMessage36.metadata) === null || _props$currentMessage37 === void 0 ? void 0 : _props$currentMessage37.quickApprove) != (nextProps === null || nextProps === void 0 ? void 0 : (_nextProps$currentMes11 = nextProps.currentMessage) === null || _nextProps$currentMes11 === void 0 ? void 0 : (_nextProps$currentMes12 = _nextProps$currentMes11.metadata) === null || _nextProps$currentMes12 === void 0 ? void 0 : _nextProps$currentMes12.quickApprove);
    },
    listViewProps: {
      onScroll: event => {
        const currentOffset = event.nativeEvent.contentOffset.y;
        const previousOffset = prevOffsetRef.current || currentOffset;
        if (currentOffset < previousOffset) {
          isScrollingManually.current = true;
        }
        prevOffsetRef.current = currentOffset;
      }
    },
    renderChatEmpty: () => {
      return _splashLogo;
    },
    renderLoadEarlier: renderLoadEarlier,
    showAvatarForEveryMessage: showAvatarForEveryMessage,
    showUserAvatar: showUserAvatar,
    alwaysShowSend: alwaysShowSend,
    maxInputLength: maxInputLength,
    messages: sortObjectsByDate(messages, sortOrder),
    onSend: messages => onSend(),
    user: user,
    renderChatFooter: () => {
      return /*#__PURE__*/React__default.createElement("div", {
        ref: endOfMessagesRef
      });
    },
    messagesContainerStyle: [{
      backgroundColor: isWebsite ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme53 = currentTheme.theme) === null || _currentTheme$theme53 === void 0 ? void 0 : _currentTheme$theme53.transparent : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme54 = currentTheme.theme) === null || _currentTheme$theme54 === void 0 ? void 0 : _currentTheme$theme54.backgroundColor,
      height: containerHeight && containerHeight
    }, messagesContainerStyle],
    renderAvatar: renderAvatar,
    renderInputToolbar: renderWithVanillaInput ? renderInputToolbar : () => /*#__PURE__*/React__default.createElement(React__default.Fragment, null),
    renderBubble: renderBubble,
    minInputToolbarHeight: renderWithVanillaInput ? 60 : 0
  }, props)), !renderWithVanillaInput && children);
};
const styleGenerator = (theme, isWebsite, textColor) => {
  var _theme$theme, _theme$theme2, _theme$theme3, _theme$theme4, _theme$theme5, _theme$theme6, _theme$theme7, _theme$theme8, _theme$theme9;
  return StyleSheet.create({
    chatContainer: {
      flex: 1,
      backgroundColor: isWebsite ? theme === null || theme === void 0 ? void 0 : (_theme$theme = theme.theme) === null || _theme$theme === void 0 ? void 0 : _theme$theme.transparent : theme === null || theme === void 0 ? void 0 : (_theme$theme2 = theme.theme) === null || _theme$theme2 === void 0 ? void 0 : _theme$theme2.lightGrey
    },
    bubbleStyle: {
      backgroundColor: isWebsite ? theme === null || theme === void 0 ? void 0 : (_theme$theme3 = theme.theme) === null || _theme$theme3 === void 0 ? void 0 : _theme$theme3.transparent : theme === null || theme === void 0 ? void 0 : (_theme$theme4 = theme.theme) === null || _theme$theme4 === void 0 ? void 0 : _theme$theme4.bubble_color,
      borderRadius: 5,
      paddingHorizontal: 12,
      paddingVertical: 8,
      width: "98%",
      borderRadius: 5
    },
    textStyle: {
      fontSize: theme === null || theme === void 0 ? void 0 : (_theme$theme5 = theme.theme) === null || _theme$theme5 === void 0 ? void 0 : _theme$theme5.base_font_size,
      lineHeight: 60,
      color: theme === null || theme === void 0 ? void 0 : theme.theme[textColor],
      marginLeft: 10
    },
    textInputStyle: {
      // borderRadius: 2,
      // borderWidth: 1,
      // borderColor: theme?.theme?.lightGrey,
      // backgroundColor: theme?.theme?.lightGrey,
      // paddingHorizontal: 12,
      // paddingVertical: 8,
      // marginLeft: 20,
      fontSize: theme === null || theme === void 0 ? void 0 : (_theme$theme6 = theme.theme) === null || _theme$theme6 === void 0 ? void 0 : _theme$theme6.extra_small_font_size,
      // lineHeight: 60,
      // minHeight: 60,
      color: theme === null || theme === void 0 ? void 0 : theme.theme[textColor]
    },
    inputToolbarStyle: {
      backgroundColor: isWebsite ? theme === null || theme === void 0 ? void 0 : (_theme$theme7 = theme.theme) === null || _theme$theme7 === void 0 ? void 0 : _theme$theme7.website_background_color : theme === null || theme === void 0 ? void 0 : (_theme$theme8 = theme.theme) === null || _theme$theme8 === void 0 ? void 0 : _theme$theme8.bubble_color,
      color: theme === null || theme === void 0 ? void 0 : theme.theme[textColor],
      padding: 10,
      borderTopColor: theme === null || theme === void 0 ? void 0 : (_theme$theme9 = theme.theme) === null || _theme$theme9 === void 0 ? void 0 : _theme$theme9.lightGrey
      //   borderWidth: 2,
      //   borderColor: theme?.theme?.lightGrey,
    }
  });
};
AppQuantumChat.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppQuantumChat",
  "props": {
    "maxInputLength": {
      "defaultValue": {
        "value": "1000",
        "computed": false
      },
      "required": false
    },
    "textInputPlaceholder": {
      "defaultValue": {
        "value": "\"Ask me anything...\"",
        "computed": false
      },
      "required": false
    },
    "messages": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false
    },
    "onSendEvent": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onCopy": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "loadEarlier": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "showAvatarForEveryMessage": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "showUserAvatar": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "alwaysShowSend": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "isTimeDisplayed": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "sendOnEnter": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "renderSendIcon": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "isDayDisplayed": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "noDelay": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "isWebsite": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "showIconOnInputLeft": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "textColor": {
      "defaultValue": {
        "value": "\"font_color\"",
        "computed": false
      },
      "required": false
    },
    "placeholderDisabled": {
      "defaultValue": {
        "value": "\"Let me think...\"",
        "computed": false
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "\"Ask me anything...\"",
        "computed": false
      },
      "required": false
    },
    "sortOrder": {
      "defaultValue": {
        "value": "\"desc\"",
        "computed": false
      },
      "required": false
    },
    "textToDisplayWhileLoading": {
      "defaultValue": {
        "value": "\"**...**\"",
        "computed": false
      },
      "required": false
    },
    "delayInMilliseconds": {
      "defaultValue": {
        "value": "10",
        "computed": false
      },
      "required": false
    },
    "suppressDisabledPlaceholder": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "allowUserToTypeWhileGeneratingResponse": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "onCancel": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "renderWithVanillaInput": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "renderMarkdown": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "S3downloadUrlRequest": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "handleShowSourcesDetails": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "showIconForGenericUser": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "allowFeedback": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "handleFeedback": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "showDuration": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "showRoutedModel": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "showLanguage": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "rlhf": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "isWidget": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "disableEditingFeedback": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "coder": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "chatid": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "customChartingConfig": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "scrollToBottom": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "showSplash": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "splashTitle": {
      "defaultValue": {
        "value": "\"Hi, how can I help?\"",
        "computed": false
      },
      "required": false
    },
    "showAgentName": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "showProcessingMetadata": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "onImageSelected": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onVideoSelected": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "listenToAudio": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "isSpeechGettingProcessed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "showTextToSpeech": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "showCodeInExecution": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "plannerMode": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "showLoading": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "cursor": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "required": false
    },
    "renderHTMLLinkPreview": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "hideReasoning": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "scrollThreshold": {
      "defaultValue": {
        "value": "0.05",
        "computed": false
      },
      "required": false
    },
    "requiresApproval": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "sendApprovalMessage": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppQuantumChat as default };
